export const mockEventsResponse = {
    objects: [
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Justice For George Floyd',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103162950%2F452190190034%2F1%2Foriginal.20200610-060525?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=98%2C0%2C624%2C312&s=5ac14d4ccda3610a5b7e04a88107238b',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103162950%2F452190190034%2F1%2Foriginal.20200610-060525?auto=format%2Ccompress&q=75&sharp=10&s=34f0b2ea6ec039fcb0d65bdfb78f598c',
                        width: 820,
                        height: 312,
                    },
                    crop_mask: {
                        width: 624,
                        height: 312,
                        top_left: {
                            y: 0,
                            x: 98,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103162950',
                },
                timezone: 'America/New_York',
                id: '108933011570',
                tickets_url:
                    'https://www.eventbrite.com/e/justice-for-george-floyd-tickets-108933011570',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30469403200',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '20:30',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                ],
                eventbrite_event_id: '108933011570',
                start_time: '16:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Lummus Park Historic District',
                    venue_profile_id: null,
                    address: {
                        city: 'Miami',
                        country: 'US',
                        region: 'FL',
                        longitude: '-80.2017156',
                        localized_address_display:
                            '404 Northwest 3rd Street, Miami, FL 33128',
                        postal_code: '33128',
                        address_1: '404 Northwest 3rd Street',
                        latitude: '25.7763816',
                        localized_multi_line_address_display: [
                            '404 Northwest 3rd Street',
                            'Miami, FL 33128',
                        ],
                        localized_area_display: 'Miami, FL',
                    },
                    venue_profile_url: '',
                    id: '51157562',
                },
                series_id: null,
                image_id: '103162950',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51157562',
                checkout_flow: 'moflo',
                name: 'Justice For George Floyd',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/justice-for-george-floyd-tickets-108933011570',
                hide_start_date: false,
                summary:
                    'Join us Sunday, June 14th, for a ☮️PEACEFUL☮️ protest against racism, discrimination, and a march for justice.',
                is_online_event: false,
                eid: '108933011570',
                published: '2020-06-10T06:07:32Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'March On Atlanta',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#707070',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102293366%2F174054211107%2F1%2Foriginal.20200531-160634?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C60%2C1920%2C960&s=d2ec40937e68d889f112384dae055b9b',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102293366%2F174054211107%2F1%2Foriginal.20200531-160634?auto=format%2Ccompress&q=75&sharp=10&s=efeeaa93104015da937b68dc54cf8fb7',
                        width: 1920,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1920,
                        height: 960,
                        top_left: {
                            y: 60,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102293366',
                },
                timezone: 'America/New_York',
                id: '107427153508',
                tickets_url:
                    'https://www.eventbrite.com/e/march-on-atlanta-registration-107427153508',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '14648287234',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/14001',
                        display_name: 'Christianity',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/114',
                        display_name: 'Religion & Spirituality',
                        localized: {
                            display_name: 'Religion & Spirituality',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Onerace',
                        display_name: 'Onerace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Marchonatlanta',
                        display_name: 'Marchonatlanta',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Oneracemovement',
                        display_name: 'Oneracemovement',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107427153508',
                start_time: '09:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Centennial Olympic Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Atlanta',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.39452949999999',
                        localized_address_display:
                            '265 Park Avenue West Northwest, Atlanta, GA 30313',
                        postal_code: '30313',
                        address_1: '265 Park Avenue West Northwest',
                        latitude: '33.7618207',
                        localized_multi_line_address_display: [
                            '265 Park Avenue West Northwest',
                            'Atlanta, GA 30313',
                        ],
                        localized_area_display: 'Atlanta, GA',
                    },
                    venue_profile_url: '',
                    id: '51047200',
                },
                series_id: null,
                image_id: '102293366',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51047200',
                checkout_flow: 'moflo',
                name: 'March On Atlanta',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/march-on-atlanta-registration-107427153508',
                hide_start_date: false,
                summary:
                    'It is time for OneRace Movement to speak out and petition God & our civic leaders for change! Join us as we March on Atlanta on June 19!',
                is_online_event: false,
                eid: 'ekhtkrk',
                published: '2020-05-31T16:06:48Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth 1,000,000 March NYC',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102849344%2F220991330008%2F1%2Foriginal.20200605-230041?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=10%2C244%2C1052%2C526&s=21b27dc04da370e71135c7df20932689',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102849344%2F220991330008%2F1%2Foriginal.20200605-230041?auto=format%2Ccompress&q=75&sharp=10&s=9ae7a19d37bb6cdc34820436058a97b0',
                        width: 1077,
                        height: 1077,
                    },
                    crop_mask: {
                        width: 1052,
                        height: 526,
                        top_left: {
                            y: 244,
                            x: 10,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102849344',
                },
                timezone: 'America/New_York',
                id: '108503422658',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-1000000-march-nyc-tickets-108503422658',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '14539694368',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Equity',
                        display_name: 'Equity',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Inclusion',
                        display_name: 'Inclusion',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Human rights',
                        display_name: 'Human rights',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Racism',
                        display_name: 'Racism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pride month',
                        display_name: 'Pride month',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/March',
                        display_name: 'March',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/We owe us',
                        display_name: 'We owe us',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108503422658',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'City Hall Park',
                    venue_profile_id: null,
                    address: {
                        city: 'New York',
                        country: 'US',
                        region: 'NY',
                        longitude: '-74.0065164',
                        localized_address_display:
                            'Chambers Street, New York, NY 10007',
                        postal_code: '10007',
                        address_1: 'Chambers Street',
                        latitude: '40.7124142',
                        localized_multi_line_address_display: [
                            'Chambers Street',
                            'New York, NY 10007',
                        ],
                        localized_area_display: 'New York, NY',
                    },
                    venue_profile_url: '',
                    id: '51052230',
                },
                series_id: null,
                image_id: '102849344',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51052230',
                checkout_flow: 'moflo',
                name: 'Juneteenth 1,000,000 March NYC',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-1000000-march-nyc-tickets-108503422658',
                hide_start_date: false,
                summary:
                    'Join the coalition of activists across Manhattan, Brooklyn, The Bronx, Staten Island, & Queen to protest for justice!',
                is_online_event: false,
                eid: 'ekkkrxb',
                published: '2020-06-05T23:04:28Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#d5dfdd',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95896743%2F426295510295%2F1%2Foriginal.20200308-183229?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C157%2C1124%2C562&s=2681400d32a8720d2f7e1b8f15e41b1a',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95896743%2F426295510295%2F1%2Foriginal.20200308-183229?auto=format%2Ccompress&q=75&sharp=10&s=3dfb2395dcc43992a90094015b5dfb77',
                        width: 1125,
                        height: 1541,
                    },
                    crop_mask: {
                        width: 1124,
                        height: 562,
                        top_left: {
                            y: 157,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '95896743',
                },
                timezone: 'America/New_York',
                id: '98897469995',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-98897469995',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29923616249',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13004',
                        display_name: 'LGBT',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Ourstories',
                        display_name: 'Ourstories',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Our culture',
                        display_name: 'Our culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Our pride',
                        display_name: 'Our pride',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '98897469995',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Williams Way Community Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Philadelphia',
                        country: 'US',
                        region: 'PA',
                        longitude: '-75.1633393',
                        localized_address_display:
                            '1315 Spruce Street, Philadelphia, PA 19107',
                        postal_code: '19107',
                        address_1: '1315 Spruce Street',
                        latitude: '39.9470772',
                        localized_multi_line_address_display: [
                            '1315 Spruce Street',
                            'Philadelphia, PA 19107',
                        ],
                        localized_area_display: 'Philadelphia, PA',
                    },
                    venue_profile_url: '',
                    id: '49343509',
                },
                series_id: null,
                image_id: '95896743',
                is_cancelled: null,
                primary_venue_id: '49343509',
                checkout_flow: 'moflo',
                name: 'Juneteenth  Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-98897469995',
                hide_start_date: false,
                summary:
                    'We would like to invite one and all to take part in our upcoming Juneteenth celebration. We rejoice in OURstories, Our Pride and Our Culture',
                is_online_event: false,
                eid: 'ehxpfcw',
                published: '2020-03-08T18:38:09Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Ride Against Racism and Police Brutality',
            event: {
                timezone: 'America/New_York',
                id: '108392119748',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-ride-against-racism-and-police-brutality-tickets-108392119748',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30436385684',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/18',
                        display_name: 'Camp, Trip, or Retreat',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#dc',
                        display_name: '#dc',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenth',
                        display_name: '#juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#rally',
                        display_name: '#rally',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#letsride',
                        display_name: '#letsride',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#stopracism',
                        display_name: '#stopracism',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108392119748',
                start_time: '00:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Washington',
                    venue_profile_id: null,
                    address: {
                        city: 'Washington',
                        country: 'US',
                        region: 'DC',
                        longitude: '-77.0368707',
                        localized_address_display: 'TBA, Washington, DC 111111',
                        postal_code: '111111',
                        address_1: 'TBA',
                        latitude: '38.9071923',
                        localized_multi_line_address_display: [
                            'TBA',
                            'Washington, DC 111111',
                        ],
                        localized_area_display: 'Washington, DC',
                    },
                    venue_profile_url: '',
                    id: '51030528',
                },
                series_id: null,
                image_id: null,
                is_cancelled: null,
                primary_venue_id: '51030528',
                checkout_flow: 'moflo',
                name: 'Juneteenth Ride Against Racism and Police Brutality',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-ride-against-racism-and-police-brutality-tickets-108392119748',
                hide_start_date: false,
                summary:
                    'We are riding to DC as a show of solidarity against racism and  police brutality.',
                is_online_event: false,
                eid: 'ekkgkfd',
                published: '2020-06-05T01:56:16Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Jubilee - Black Lives Matter Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#eda827',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103007988%2F291574798741%2F1%2Foriginal.20200608-200046?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C60%2C1920%2C960&s=345571c552c9a541a867ac244e05e2f2',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103007988%2F291574798741%2F1%2Foriginal.20200608-200046?auto=format%2Ccompress&q=75&sharp=10&s=c548a4706573d1c35922a3a26251578b',
                        width: 1920,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1920,
                        height: 960,
                        top_left: {
                            y: 60,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103007988',
                },
                timezone: 'America/New_York',
                id: '108656480458',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-jubilee-black-lives-matter-celebration-tickets-108656480458',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18735892571',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Scranton pa',
                        display_name: 'Scranton pa',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black scranton',
                        display_name: 'Black scranton',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108656480458',
                start_time: '16:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Nay Aug Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Scranton',
                        country: 'US',
                        region: 'PA',
                        longitude: '-75.64140549999999',
                        localized_address_display:
                            '500 Arthur Avenue, Scranton, PA 18510',
                        postal_code: '18510',
                        address_1: '500 Arthur Avenue',
                        latitude: '41.4013064',
                        localized_multi_line_address_display: [
                            '500 Arthur Avenue',
                            'Scranton, PA 18510',
                        ],
                        localized_area_display: 'Scranton, PA',
                    },
                    venue_profile_url: '',
                    id: '51098382',
                },
                series_id: null,
                image_id: '103007988',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51098382',
                checkout_flow: 'moflo',
                name: 'Juneteenth Jubilee - Black Lives Matter Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-jubilee-black-lives-matter-celebration-tickets-108656480458',
                hide_start_date: false,
                summary:
                    'In our efforts to continue fighting against social injustice, we present JUNETEENTH JUBILEE',
                is_online_event: false,
                eid: 'ekkqyhw',
                published: '2020-06-08T05:44:23Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Black Lives Matter Fashion Protest',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102405576%2F402391235539%2F1%2Foriginal.20200601-224808?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=f522461e2d7beeb2663942d7ea8079e8',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102405576%2F402391235539%2F1%2Foriginal.20200601-224808?auto=format%2Ccompress&q=75&sharp=10&s=3b7be186f6c398b1b151b23817499256',
                        width: 2160,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102405576',
                },
                timezone: 'America/New_York',
                id: '107584746874',
                tickets_url:
                    'https://www.eventbrite.com/e/black-lives-matter-fashion-protest-registration-107584746874',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29756579117',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '14:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/6001',
                        display_name: 'Fashion',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/106',
                        display_name: 'Fashion & Beauty',
                        localized: {
                            display_name: 'Fashion & Beauty',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Music',
                        display_name: 'Music',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fashion',
                        display_name: 'Fashion',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fashion show',
                        display_name: 'Fashion show',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Designer',
                        display_name: 'Designer',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Philadelphia',
                        display_name: 'Philadelphia',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pro black',
                        display_name: 'Pro black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/George floyd',
                        display_name: 'George floyd',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107584746874',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Liberty Bell',
                    venue_profile_id: null,
                    address: {
                        city: 'Philadelphia',
                        country: 'US',
                        region: 'PA',
                        longitude: '-75.1502821',
                        localized_address_display:
                            '526 Market Street, Philadelphia, PA 19106',
                        postal_code: '19106',
                        address_1: '526 Market Street',
                        latitude: '39.9496103',
                        localized_multi_line_address_display: [
                            '526 Market Street',
                            'Philadelphia, PA 19106',
                        ],
                        localized_area_display: 'Philadelphia, PA',
                    },
                    venue_profile_url: '',
                    id: '50948252',
                },
                series_id: null,
                image_id: '102405576',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '50948252',
                checkout_flow: 'moflo',
                name: 'Black Lives Matter Fashion Protest',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/black-lives-matter-fashion-protest-registration-107584746874',
                hide_start_date: false,
                summary:
                    "We March in solidarity. We march in peace. We march with conviction & We March so that when it's time to fight we do it together.",
                is_online_event: false,
                eid: 'ekhrryd',
                published: '2020-06-01T20:19:04Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Families for Black Lives',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#8e826b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103250768%2F61127265443%2F1%2Foriginal.20200610-224003?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=6a4692f8ac4a2615cad005d822497b6e',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103250768%2F61127265443%2F1%2Foriginal.20200610-224003?auto=format%2Ccompress&q=75&sharp=10&s=2ad2f64895657059f08f0e7b7e410a46',
                        width: 2160,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103250768',
                },
                timezone: 'America/Los_Angeles',
                id: '108485856116',
                tickets_url:
                    'https://www.eventbrite.com/e/families-for-black-lives-tickets-108485856116',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30442290732',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '15:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pasadena',
                        display_name: 'Pasadena',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Familyfriendly',
                        display_name: 'Familyfriendly',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Rosebowl',
                        display_name: 'Rosebowl',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peacefulprotest',
                        display_name: 'Peacefulprotest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peacefulpicnic',
                        display_name: 'Peacefulpicnic',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/June20',
                        display_name: 'June20',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blmprotest',
                        display_name: 'Blmprotest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pasadenaprotest',
                        display_name: 'Pasadenaprotest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Familyprotest',
                        display_name: 'Familyprotest',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108485856116',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Rose Bowl Lawn',
                    venue_profile_id: null,
                    address: {
                        city: 'Pasadena',
                        country: 'US',
                        region: 'CA',
                        longitude: '-118.1638591',
                        localized_address_display:
                            'Seco St & Rosemont Ave, Pasadena, CA 91103',
                        postal_code: '91103',
                        address_1: 'Seco St & Rosemont Ave',
                        latitude: '34.1577053',
                        localized_multi_line_address_display: [
                            'Seco St & Rosemont Ave',
                            'Pasadena, CA 91103',
                        ],
                        localized_area_display: 'Pasadena, CA',
                    },
                    venue_profile_url: '',
                    id: '51177088',
                },
                series_id: null,
                image_id: '103250768',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51177088',
                checkout_flow: 'moflo',
                name: 'Families for Black Lives',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/families-for-black-lives-tickets-108485856116',
                hide_start_date: false,
                summary:
                    'Join us on Saturday, June 20 on the Rose Bowl Lawn for a free family-friendly, COVID safe, peaceful event in solidarity with Black Lives Mat',
                is_online_event: false,
                eid: 'ekkkfqb',
                published: '2020-06-10T22:45:32Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Unity Ride for Reform - Black out the Sun',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#5175a2',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103434796%2F262269898397%2F1%2Foriginal.20200612-173116?w=210&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C8%2C210%2C105&s=a00c15bd2b1958306c930e93a470e8e3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103434796%2F262269898397%2F1%2Foriginal.20200612-173116?auto=format%2Ccompress&q=75&sharp=10&s=a001bdc401aa5256dfbf676f5594b3f6',
                        width: 213,
                        height: 320,
                    },
                    crop_mask: {
                        width: 210,
                        height: 105,
                        top_left: {
                            y: 8,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103434796',
                },
                timezone: 'America/Chicago',
                id: '108862213812',
                tickets_url:
                    'https://www.eventbrite.com/e/unity-ride-for-reform-rally-tickets-108862213812',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17523694167',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Justice',
                        display_name: 'Justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peace',
                        display_name: 'Peace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Activist',
                        display_name: 'Activist',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Motorcycles',
                        display_name: 'Motorcycles',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Police brutality',
                        display_name: 'Police brutality',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black bikers',
                        display_name: 'Black bikers',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108862213812',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Dallas City Hall',
                    venue_profile_id: null,
                    address: {
                        city: 'Dallas',
                        country: 'US',
                        region: 'TX',
                        longitude: '-96.7970783',
                        localized_address_display:
                            '1500 Marilla Street, Dallas, TX 75201',
                        postal_code: '75201',
                        address_1: '1500 Marilla Street',
                        latitude: '32.7764068',
                        localized_multi_line_address_display: [
                            '1500 Marilla Street',
                            'Dallas, TX 75201',
                        ],
                        localized_area_display: 'Dallas, TX',
                    },
                    venue_profile_url: '',
                    id: '51136282',
                },
                series_id: null,
                image_id: '103434796',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51136282',
                checkout_flow: 'moflo',
                name: 'Unity Ride for Reform & Rally',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/unity-ride-for-reform-rally-tickets-108862213812',
                hide_start_date: false,
                summary:
                    'Peaceful protest & rally for DFW MCs, RCs,  SCs & Independents honoring black Americans slain from police brutality.',
                is_online_event: false,
                eid: 'ekkyckg',
                published: '2020-06-09T18:08:44Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Charity Bike Ride',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102872634%2F196993626799%2F1%2Foriginal.20200606-211440?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C65%2C580%2C290&s=daf865270269ad61166cdde853fb4097',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102872634%2F196993626799%2F1%2Foriginal.20200606-211440?auto=format%2Ccompress&q=75&sharp=10&s=4a1c97e4043f11d50379616c675982a3',
                        width: 580,
                        height: 370,
                    },
                    crop_mask: {
                        width: 580,
                        height: 290,
                        top_left: {
                            y: 65,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102872634',
                },
                timezone: 'America/New_York',
                id: '108544920780',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-charity-bike-ride-tickets-108544920780',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30445909890',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Charity bike ride',
                        display_name: 'Charity bike ride',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/The round table',
                        display_name: 'The round table',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108544920780',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Central Park',
                    venue_profile_id: null,
                    address: {
                        city: 'New York',
                        country: 'US',
                        region: 'NY',
                        longitude: '-73.9653551',
                        localized_address_display:
                            '110th & 7th Avenue, New York, NY',
                        address_1: '110th & 7th Avenue',
                        latitude: '40.7828647',
                        localized_multi_line_address_display: [
                            '110th & 7th Avenue',
                            'New York, NY',
                        ],
                        localized_area_display: 'New York, NY',
                    },
                    venue_profile_url: '',
                    id: '51068058',
                },
                series_id: null,
                image_id: '102872634',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51068058',
                checkout_flow: 'moflo',
                name: 'Juneteenth Charity Bike Ride',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-charity-bike-ride-tickets-108544920780',
                hide_start_date: false,
                summary:
                    'Mimms, Inc. and The Round Table will be coordinating a charity bike ride to support the National Bail Fund Network.',
                is_online_event: false,
                eid: 'ekkmqhb',
                published: '2020-06-08T16:38:57Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'March on San Francisco for Jobs and Freedom',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#93b0cd',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102391660%2F73407892263%2F1%2Foriginal.20200601-201128?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C153%2C1538%2C769&s=be02d38b11abf74ff6ab8cf205a75907',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102391660%2F73407892263%2F1%2Foriginal.20200601-201128?auto=format%2Ccompress&q=75&sharp=10&s=edd3fdd120fd625e29b6451504768317',
                        width: 1538,
                        height: 1001,
                    },
                    crop_mask: {
                        width: 1538,
                        height: 769,
                        top_left: {
                            y: 153,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102391660',
                },
                timezone: 'America/Los_Angeles',
                id: '107609753670',
                tickets_url:
                    'https://www.eventbrite.com/e/march-on-san-francisco-for-jobs-and-freedom-tickets-107609753670',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30410540022',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/112',
                        display_name: 'Government & Politics',
                        localized: {
                            display_name: 'Government & Politics',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Movement',
                        display_name: 'Movement',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Nonviolence',
                        display_name: 'Nonviolence',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peaceful demonstration',
                        display_name: 'Peaceful demonstration',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107609753670',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Ferry Building',
                    venue_profile_id: null,
                    address: {
                        city: 'San Francisco',
                        country: 'US',
                        region: 'CA',
                        longitude: '-122.3937801',
                        localized_address_display:
                            '1 Ferry Building, San Francisco, CA 94111',
                        postal_code: '94111',
                        address_1: '1 Ferry Building',
                        latitude: '37.7958379',
                        localized_multi_line_address_display: [
                            '1 Ferry Building',
                            'San Francisco, CA 94111',
                        ],
                        localized_area_display: 'San Francisco, CA',
                    },
                    venue_profile_url: '',
                    id: '50953292',
                },
                series_id: null,
                image_id: '102391660',
                is_cancelled: null,
                primary_venue_id: '50953292',
                checkout_flow: 'moflo',
                name: 'March on San Francisco for Jobs and Freedom',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/march-on-san-francisco-for-jobs-and-freedom-tickets-107609753670',
                hide_start_date: false,
                summary:
                    'Please join us as we peacefully protest and march for the injustices, disease outbreaks, and economic devastation wreaking havoc worldwide.',
                is_online_event: false,
                eid: 'ekhtgpg',
                published: '2020-06-01T20:16:58Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'POC/Cosplayers For Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102957070%2F391655278243%2F1%2Foriginal.20200608-121555?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=7%2C0%2C864%2C432&s=141ae1a4951fa456cdd5c9138bcee900',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102957070%2F391655278243%2F1%2Foriginal.20200608-121555?auto=format%2Ccompress&q=75&sharp=10&s=2dc711de1b754d43ed5e2070f3061a8e',
                        width: 892,
                        height: 432,
                    },
                    crop_mask: {
                        width: 864,
                        height: 432,
                        top_left: {
                            y: 0,
                            x: 7,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102957070',
                },
                timezone: 'America/Detroit',
                id: '108683547416',
                tickets_url:
                    'https://www.eventbrite.com/e/poccosplayers-for-juneteenth-celebration-tickets-108683547416',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29034717209',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cosplay',
                        display_name: 'Cosplay',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Youmacon',
                        display_name: 'Youmacon',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108683547416',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Mt. Elliott Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Detroit',
                        country: 'US',
                        region: 'MI',
                        longitude: '-83.00743349999999',
                        localized_address_display:
                            '110 Mount Elliott Street, Detroit, MI 48207',
                        postal_code: '48207',
                        address_1: '110 Mount Elliott Street',
                        latitude: '42.3414518',
                        localized_multi_line_address_display: [
                            '110 Mount Elliott Street',
                            'Detroit, MI 48207',
                        ],
                        localized_area_display: 'Detroit, MI',
                    },
                    venue_profile_url: '',
                    id: '51105386',
                },
                series_id: null,
                image_id: '102957070',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51105386',
                checkout_flow: 'moflo',
                name: 'POC/Cosplayers For Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/poccosplayers-for-juneteenth-celebration-tickets-108683547416',
                hide_start_date: false,
                summary:
                    'Wakanda Forever....Lets celebrate Juneteenth in the most exciting way!',
                is_online_event: false,
                eid: 'ekkrqfp',
                published: '2020-06-08T12:16:07Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Justice for George. Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#0c0c0a',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102629248%2F124030746969%2F1%2Foriginal.20200603-234559?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=76%2C255%2C3388%2C1694&s=2bcb1f6be2bfd610702a290b7c2bbdad',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102629248%2F124030746969%2F1%2Foriginal.20200603-234559?auto=format%2Ccompress&q=75&sharp=10&s=3c09f0265e17fc4a7c565e4dda661df7',
                        width: 3464,
                        height: 3464,
                    },
                    crop_mask: {
                        width: 3388,
                        height: 1694,
                        top_left: {
                            y: 255,
                            x: 76,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102629248',
                },
                timezone: 'America/Chicago',
                id: '108045103814',
                tickets_url:
                    'https://www.eventbrite.com/e/justice-for-george-juneteenth-celebration-tickets-108045103814',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '15879523980',
                hide_end_date: true,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                ],
                eventbrite_event_id: '108045103814',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Greater Pleasant Green Baptist Church',
                    venue_profile_id: null,
                    address: {
                        city: 'Chicago',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.66124909999999',
                        localized_address_display:
                            '1557 W 115TH STREET, Chicago, IL 60643',
                        postal_code: '60643',
                        address_1: '1557 W 115TH STREET',
                        latitude: '41.6845489',
                        localized_multi_line_address_display: [
                            '1557 W 115TH STREET',
                            'Chicago, IL 60643',
                        ],
                        localized_area_display: 'Chicago, IL',
                    },
                    venue_profile_url: '',
                    id: '51003810',
                },
                series_id: null,
                image_id: '102629248',
                is_cancelled: null,
                primary_venue_id: '51003810',
                checkout_flow: 'moflo',
                name: 'Justice for George. Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/justice-for-george-juneteenth-celebration-tickets-108045103814',
                hide_start_date: false,
                summary:
                    'In response to the series of events that took place following George Floyd’s murder, we will be having a Juneteenth Fundraiser!',
                is_online_event: false,
                eid: '108045103814',
                published: '2020-06-05T03:05:09Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '2020 Juneteenth Community Celebration',
            event: {
                timezone: 'America/New_York',
                id: '108998700046',
                tickets_url:
                    'https://www.eventbrite.com/e/2020-juneteenth-community-celebration-tickets-108998700046',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30473936714',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/History',
                        display_name: 'History',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community outreach',
                        display_name: 'Community outreach',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black community',
                        display_name: 'Black community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pine hills',
                        display_name: 'Pine hills',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Defund the police',
                        display_name: 'Defund the police',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Free food and games',
                        display_name: 'Free food and games',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108998700046',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Silver Star Christian Church',
                    venue_profile_id: null,
                    address: {
                        city: 'Orlando',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.48470300000001',
                        localized_address_display:
                            '7510 Silver Star Road, Orlando, FL 32818',
                        postal_code: '32818',
                        address_1: '7510 Silver Star Road',
                        latitude: '28.5769577',
                        localized_multi_line_address_display: [
                            '7510 Silver Star Road',
                            'Orlando, FL 32818',
                        ],
                        localized_area_display: 'Orlando, FL',
                    },
                    venue_profile_url: '',
                    id: '51167754',
                },
                series_id: null,
                image_id: null,
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51167754',
                checkout_flow: 'moflo',
                name: '2020 Juneteenth Community Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/2020-juneteenth-community-celebration-tickets-108998700046',
                hide_start_date: false,
                summary:
                    'Juneteenth is the oldest known celebration honoring the end of slavery in the United States.',
                is_online_event: false,
                eid: 'ekmchfb',
                published: '2020-06-10T15:03:31Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '1st Annual Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102649456%2F450961915882%2F1%2Foriginal.20200604-061125?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C62%2C750%2C375&s=3e3b393aaee26d2279379d971e45f3cc',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102649456%2F450961915882%2F1%2Foriginal.20200604-061125?auto=format%2Ccompress&q=75&sharp=10&s=7d7615dab4d77ba57763f88265a3a4a8',
                        width: 750,
                        height: 500,
                    },
                    crop_mask: {
                        width: 750,
                        height: 375,
                        top_left: {
                            y: 62,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102649456',
                },
                timezone: 'America/Chicago',
                id: '108068850842',
                tickets_url:
                    'https://www.eventbrite.com/e/1st-annual-juneteenth-celebration-tickets-108068850842',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30429562252',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Non-profit organization',
                        display_name: 'Non-profit organization',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/For the culture',
                        display_name: 'For the culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community action',
                        display_name: 'Community action',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth celebration',
                        display_name: 'Juneteenth celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/June 19th',
                        display_name: 'June 19th',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/African american freedom',
                        display_name: 'African american freedom',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth festival',
                        display_name: 'Juneteenth festival',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108068850842',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Mobile Community Action Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Prichard',
                        country: 'US',
                        region: 'AL',
                        longitude: '-88.0826695',
                        localized_address_display:
                            '508 Dunlap Circle, Prichard, AL 36610',
                        postal_code: '36610',
                        address_1: '508 Dunlap Circle',
                        latitude: '30.751908',
                        localized_multi_line_address_display: [
                            '508 Dunlap Circle',
                            'Prichard, AL 36610',
                        ],
                        localized_area_display: 'Prichard, AL',
                    },
                    venue_profile_url: '',
                    id: '51009440',
                },
                series_id: null,
                image_id: '102649456',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51009440',
                checkout_flow: 'moflo',
                name: '1st Annual Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/1st-annual-juneteenth-celebration-tickets-108068850842',
                hide_start_date: false,
                summary:
                    'Celebrating the day of our true freedom, our 1st Annual Juneteenth Celebration! Bring your family and friends for a day of fun & community.',
                is_online_event: false,
                eid: 'ekkctzb',
                published: '2020-06-04T05:46:47Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '4th ANNUAL JUNETEENTH CELEBRATION',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#a77441',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F93762339%2F59474548847%2F1%2Foriginal.20200223-185023?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C830%2C1274%2C637&s=143253e4657d8f31df0775cb10f8464e',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F93762339%2F59474548847%2F1%2Foriginal.20200223-185023?auto=format%2Ccompress&q=75&sharp=10&s=9219e6b9d79793e82d138e60b8248214',
                        width: 1275,
                        height: 1875,
                    },
                    crop_mask: {
                        width: 1274,
                        height: 637,
                        top_left: {
                            y: 830,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '93762339',
                },
                timezone: 'America/Chicago',
                id: '96342857079',
                tickets_url:
                    'https://www.eventbrite.com/e/4th-annual-juneteenth-celebration-tickets-96342857079',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '16526769202',
                hide_end_date: false,
                start_date: '2020-06-21',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-21',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                ],
                eventbrite_event_id: '96342857079',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Harker Heights Event Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Harker Heights',
                        country: 'US',
                        region: 'TX',
                        longitude: '-97.64691099999999',
                        localized_address_display:
                            '710 Edwards Dr, Harker Heights, TX 76548',
                        postal_code: '76548',
                        address_1: '710 Edwards Dr',
                        latitude: '31.083003',
                        localized_multi_line_address_display: [
                            '710 Edwards Dr',
                            'Harker Heights, TX 76548',
                        ],
                        localized_area_display: 'Harker Heights, TX',
                    },
                    venue_profile_url: '',
                    id: '48446867',
                },
                series_id: null,
                image_id: '93762339',
                is_cancelled: null,
                primary_venue_id: '48446867',
                checkout_flow: 'moflo',
                name: '4th ANNUAL JUNETEENTH CELEBRATION',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/4th-annual-juneteenth-celebration-tickets-96342857079',
                hide_start_date: false,
                summary:
                    '4th Annual Juneteenth Celebration \nHonoring our Kings & Queens',
                is_online_event: false,
                eid: '96342857079',
                published: '2020-02-23T19:17:29Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '2nd Annual Juneteenth Celebration: We All We Got!',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#624941',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102864262%2F290454922097%2F1%2Foriginal.20200606-172542?w=300&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C102%2C300%2C150&s=1a4dfa2d76c94f8953040bd941c762bb',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102864262%2F290454922097%2F1%2Foriginal.20200606-172542?auto=format%2Ccompress&q=75&sharp=10&s=9fe8b533ca000eb45e64e3ebafd88dac',
                        width: 300,
                        height: 300,
                    },
                    crop_mask: {
                        width: 300,
                        height: 150,
                        top_left: {
                            y: 102,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102864262',
                },
                timezone: 'America/New_York',
                id: '108558156368',
                tickets_url:
                    'https://www.eventbrite.com/e/2nd-annual-juneteenth-celebration-we-all-we-got-tickets-108558156368',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18637091773',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/We all we got',
                        display_name: 'We all we got',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black celebration',
                        display_name: 'Black celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth celebration',
                        display_name: 'Juneteenth celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth bbq',
                        display_name: 'Juneteenth bbq',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atl block party',
                        display_name: 'Atl block party',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atl juneteenth',
                        display_name: 'Atl juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth block party',
                        display_name: 'Juneteenth block party',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108558156368',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Phoenix II Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Atlanta',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.3833265',
                        localized_address_display:
                            '141 Martin Street Southeast, Atlanta, GA 30312',
                        postal_code: '30312',
                        address_1: '141 Martin Street Southeast',
                        latitude: '33.7343029',
                        localized_multi_line_address_display: [
                            '141 Martin Street Southeast',
                            'Atlanta, GA 30312',
                        ],
                        localized_area_display: 'Atlanta, GA',
                    },
                    venue_profile_url: '',
                    id: '51173674',
                },
                series_id: null,
                image_id: '102864262',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51173674',
                checkout_flow: 'moflo',
                name: '2nd Annual Juneteenth Celebration: We All We Got!',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/2nd-annual-juneteenth-celebration-we-all-we-got-tickets-108558156368',
                hide_start_date: false,
                summary:
                    'Our 2nd Annual Juneteenth Celebration,  sponsored by Free Dope Creative and Oui, Can Cook.',
                is_online_event: false,
                eid: 'ekkmybr',
                published: '2020-06-06T17:32:25Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '4th Annual Juneteenth Freedom Fest',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#856632',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102518912%2F253194450870%2F1%2Foriginal.20200603-034726?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C289%2C634%2C317&s=7fc0c122e78503ca6c35940e87783300',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102518912%2F253194450870%2F1%2Foriginal.20200603-034726?auto=format%2Ccompress&q=75&sharp=10&s=f6fd4985cb110e469a2ed62185c5588a',
                        width: 634,
                        height: 896,
                    },
                    crop_mask: {
                        width: 634,
                        height: 317,
                        top_left: {
                            y: 289,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102518912',
                },
                timezone: 'America/New_York',
                id: '90180238521',
                tickets_url:
                    'https://www.eventbrite.com/e/4th-annual-juneteenth-freedom-fest-tickets-90180238521',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '19955251752',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [],
                eventbrite_event_id: '90180238521',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name:
                        '4622 N Main St, Columbia, SC 29203-5976, United States',
                    venue_profile_id: null,
                    address: {
                        localized_multi_line_address_display: [],
                        country: 'US',
                        longitude: '-81.03358',
                        latitude: '34.04541',
                    },
                    venue_profile_url: '',
                    id: '50953938',
                },
                series_id: null,
                image_id: '102518912',
                is_cancelled: null,
                primary_venue_id: '50953938',
                checkout_flow: 'moflo',
                name: '4th Annual Juneteenth Freedom Fest',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/4th-annual-juneteenth-freedom-fest-tickets-90180238521',
                hide_start_date: false,
                summary:
                    'Juneteenth or June 19th is the oldest known celebration commemorating the 1865 emancipation of the last enslaved people in the United States. Juneteenth commemorates and emphasizes education, freedom, and the overall achievement of African Americans. A day, a week, and in some cities, a month long celebration. Juneteenth is a time for reflection and rejoicing. It is a time for community assessment, self-improvement, and planning for the future.  Across our country, the contributions of African A',
                is_online_event: false,
                eid: '90180238521',
                published: '2020-01-16T17:26:54Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                '6/14 Hip-Hop Dance Class for #BlackLivesMatter | All Levels | By RESIDANCE',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#300d1e',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103157654%2F362482135793%2F1%2Foriginal.20200610-040533?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=300%2C0%2C6554%2C3277&s=03516ea625698ef72ca192f8e8ff6df7',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103157654%2F362482135793%2F1%2Foriginal.20200610-040533?auto=format%2Ccompress&q=75&sharp=10&s=3d87af9eb850f034dd5c5ce3eafa4f01',
                        width: 7154,
                        height: 3277,
                    },
                    crop_mask: {
                        width: 6554,
                        height: 3277,
                        top_left: {
                            y: 0,
                            x: 300,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103157654',
                },
                timezone: 'America/New_York',
                id: '108948116750',
                tickets_url:
                    'https://www.eventbrite.com/e/614-hip-hop-dance-class-for-blacklivesmatter-all-levels-by-residance-tickets-108948116750',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '27916002643',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '17:30',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/5004',
                        display_name: 'Dance',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/105',
                        display_name: 'Performing & Visual Arts',
                        localized: {
                            display_name: 'Performing & Visual Arts',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/9',
                        display_name: 'Class, Training, or Workshop',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hip hop',
                        display_name: 'Hip hop',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Dancing',
                        display_name: 'Dancing',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Dance class',
                        display_name: 'Dance class',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Adult dance class',
                        display_name: 'Adult dance class',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Residance',
                        display_name: 'Residance',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hip-hop dance class',
                        display_name: 'Hip-hop dance class',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Urban dance class',
                        display_name: 'Urban dance class',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Dance adults',
                        display_name: 'Dance adults',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108948116750',
                start_time: '16:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Inside Edison Mall',
                    venue_profile_id: null,
                    address: {
                        city: 'Fort Myers',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.86921640000003',
                        localized_address_display:
                            '4125 Cleveland Ave Unit 1920, Fort Myers, FL 33901',
                        postal_code: '33901',
                        address_1: '4125 Cleveland Ave',
                        address_2: 'Unit 1920',
                        latitude: '26.6015082',
                        localized_multi_line_address_display: [
                            '4125 Cleveland Ave',
                            'Unit 1920',
                            'Fort Myers, FL 33901',
                        ],
                        localized_area_display: 'Fort Myers, FL',
                    },
                    venue_profile_url: '',
                    id: '51155402',
                },
                series_id: null,
                image_id: '103157654',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51155402',
                checkout_flow: 'moflo',
                name:
                    '6/14  Hip-Hop Dance Class for #BlackLivesMatter | All Levels | By RESIDANCE',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/614-hip-hop-dance-class-for-blacklivesmatter-all-levels-by-residance-tickets-108948116750',
                hide_start_date: false,
                summary:
                    'This class is to raise funds for the Black Lives Matter movement.',
                is_online_event: false,
                eid: 'ekmbdkp',
                published: '2020-06-10T04:06:20Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'BLACK FATHERS MATTER TOO FAMILY WALK',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103267294%2F383447418615%2F1%2Foriginal.20200611-023622?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C0%2C1124%2C562&s=37aa919bda43e31e1acc29d99799f0e9',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103267294%2F383447418615%2F1%2Foriginal.20200611-023622?auto=format%2Ccompress&q=75&sharp=10&s=8dab401d878ace7abf4e9bc0aab6c0ca',
                        width: 1125,
                        height: 1012,
                    },
                    crop_mask: {
                        width: 1124,
                        height: 562,
                        top_left: {
                            y: 0,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103267294',
                },
                timezone: 'America/New_York',
                id: '108783083130',
                tickets_url:
                    'https://www.eventbrite.com/e/black-fathers-matter-too-family-walk-tickets-108783083130',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28683223859',
                hide_end_date: false,
                start_date: '2020-06-21',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-21',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13008',
                        display_name: 'Nationality',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                ],
                eventbrite_event_id: '108783083130',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Martin Luther King Monument ',
                    venue_profile_id: null,
                    address: {
                        city: 'Norfolk',
                        country: 'US',
                        region: 'VA',
                        longitude: '-76.2788056',
                        localized_address_display: 'Church Street, Norfolk, VA',
                        address_1: 'Church Street',
                        latitude: '36.8631369',
                        localized_multi_line_address_display: [
                            'Church Street',
                            'Norfolk, VA',
                        ],
                        localized_area_display: 'Norfolk, VA',
                    },
                    venue_profile_url: '',
                    id: '51118240',
                },
                series_id: null,
                image_id: '103267294',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51118240',
                checkout_flow: 'moflo',
                name: 'BLACK FATHERS MATTER TOO FAMILY WALK',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/black-fathers-matter-too-family-walk-tickets-108783083130',
                hide_start_date: false,
                summary: 'Celebrate our Black Fathers!',
                is_online_event: false,
                eid: '108783083130',
                published: '2020-06-08T22:33:20Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Beats To Fade Injustice',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#1d1e22',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103402914%2F255503418289%2F1%2Foriginal.20200612-115212?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=42%2C0%2C1040%2C520&s=067b2b5ba36c1ab2f26ac1e8d8c131b4',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103402914%2F255503418289%2F1%2Foriginal.20200612-115212?auto=format%2Ccompress&q=75&sharp=10&s=6cf7567643bbca4bee31c4fac4864e56',
                        width: 1125,
                        height: 520,
                    },
                    crop_mask: {
                        width: 1040,
                        height: 520,
                        top_left: {
                            y: 0,
                            x: 42,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103402914',
                },
                timezone: 'America/New_York',
                id: '108814081848',
                tickets_url:
                    'https://www.eventbrite.com/e/beats-to-fade-injustice-tickets-108814081848',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30470516942',
                hide_end_date: false,
                start_date: '2020-06-28',
                end_time: '15:00',
                _type: 'destination_event',
                end_date: '2020-06-28',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13010',
                        display_name: 'Historic',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Justice',
                        display_name: 'Justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Equality',
                        display_name: 'Equality',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Social injustice',
                        display_name: 'Social injustice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Police brutality',
                        display_name: 'Police brutality',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peaceful protests',
                        display_name: 'Peaceful protests',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108814081848',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Privado Grooming Suites',
                    venue_profile_id: null,
                    address: {
                        city: 'Atlanta',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.41019349999999',
                        localized_address_display:
                            '320 Sunset Ave NW, Atlanta, GA 30314',
                        postal_code: '30314',
                        address_1: '320 Sunset Ave NW',
                        latitude: '33.7633127',
                        localized_multi_line_address_display: [
                            '320 Sunset Ave NW',
                            'Atlanta, GA 30314',
                        ],
                        localized_area_display: 'Atlanta, GA',
                    },
                    venue_profile_url: '',
                    id: '51124406',
                },
                series_id: null,
                image_id: '103402914',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51124406',
                checkout_flow: 'moflo',
                name: 'Beats To Fade Injustice',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/beats-to-fade-injustice-tickets-108814081848',
                hide_start_date: false,
                summary:
                    'The PG Team alongside special guest barbers are collaborating  to bring synergy and grooming together for a cause. Goal Amount: $10,000',
                is_online_event: false,
                eid: 'ekkwzyg',
                published: '2020-06-10T21:26:51Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Chill Vibez Juneteenth Celebration ',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#595959',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103033244%2F360174949757%2F1%2Foriginal.20200609-011646?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C540%2C1080%2C540&s=996ac143c5d8df39fa7427753fcfe952',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103033244%2F360174949757%2F1%2Foriginal.20200609-011646?auto=format%2Ccompress&q=75&sharp=10&s=992c38cce98685bf0e2f0c04d1ac3753',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 540,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103033244',
                },
                timezone: 'America/Chicago',
                id: '108775352006',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-chill-vibez-celebration-tickets-108775352006',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '27816877591',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '22:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/199',
                        display_name: 'Other',
                        localized: {
                            display_name: 'Other',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Food',
                        display_name: 'Food',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Music',
                        display_name: 'Music',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Vendors',
                        display_name: 'Vendors',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black',
                        display_name: 'Black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Non profit',
                        display_name: 'Non profit',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blackowned',
                        display_name: 'Blackowned',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fortheculture',
                        display_name: 'Fortheculture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Jcm',
                        display_name: 'Jcm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108775352006',
                start_time: '18:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'JCM House',
                    venue_profile_id: null,
                    address: {
                        city: 'Madison',
                        country: 'US',
                        region: 'TN',
                        longitude: '-86.67336639999996',
                        localized_address_display:
                            '616 Aideen Pl., Madison, TN 37115',
                        postal_code: '37115',
                        address_1: '616 Aideen Pl.',
                        latitude: '36.2548835',
                        localized_multi_line_address_display: [
                            '616 Aideen Pl.',
                            'Madison, TN 37115',
                        ],
                        localized_area_display: 'Madison, TN',
                    },
                    venue_profile_url: '',
                    id: '51117414',
                },
                series_id: null,
                image_id: '103033244',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51117414',
                checkout_flow: 'moflo',
                name: 'JuneTeenth Chill Vibez Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-chill-vibez-celebration-tickets-108775352006',
                hide_start_date: false,
                summary:
                    'Juneteenth Chill Vibez will be an event where Black Bussiness the culture will be celebrated.  A percentage of proceeds will go towards BLM',
                is_online_event: false,
                eid: 'ekkwfzw',
                published: '2020-06-09T01:40:11Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Breaking the Chains // Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102977668%2F234154863211%2F1%2Foriginal.20200608-153836?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C60%2C1920%2C960&s=8efd01ba148d1bc801b418b58a5f3c58',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102977668%2F234154863211%2F1%2Foriginal.20200608-153836?auto=format%2Ccompress&q=75&sharp=10&s=ba14d08f56bf2e07e517a661566145f2',
                        width: 1920,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1920,
                        height: 960,
                        top_left: {
                            y: 60,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102977668',
                },
                timezone: 'America/New_York',
                id: '108714259276',
                tickets_url:
                    'https://www.eventbrite.com/e/breaking-the-chains-juneteenth-celebration-tickets-108714259276',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '15886651526',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/7005',
                        display_name: 'Yoga',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/107',
                        display_name: 'Health & Wellness',
                        localized: {
                            display_name: 'Health & Wellness',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Yoga',
                        display_name: 'Yoga',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Health',
                        display_name: 'Health',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Wellness',
                        display_name: 'Wellness',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Celebration',
                        display_name: 'Celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Meditation',
                        display_name: 'Meditation',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108714259276',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Franklin Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Boston',
                        country: 'US',
                        region: 'MA',
                        longitude: '-71.0868152',
                        localized_address_display:
                            '1 Franklin Park Road, Boston, MA 02121',
                        postal_code: '02121',
                        address_1: '1 Franklin Park Road',
                        latitude: '42.30307380000001',
                        localized_multi_line_address_display: [
                            '1 Franklin Park Road',
                            'Boston, MA 02121',
                        ],
                        localized_area_display: 'Boston, MA',
                    },
                    venue_profile_url: '',
                    id: '51112228',
                },
                series_id: null,
                image_id: '102977668',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51112228',
                checkout_flow: 'moflo',
                name: 'Breaking the Chains // Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/breaking-the-chains-juneteenth-celebration-tickets-108714259276',
                hide_start_date: false,
                summary:
                    'Join us for a peaceful celebration of Juneteenth. Relax and release some stress from a gentle yoga session, meditation + more...',
                is_online_event: false,
                eid: 'ekkrzzr',
                published: '2020-06-08T16:24:48Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Community Unity in Economics',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103222034%2F37045632812%2F1%2Foriginal.20200610-180232?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=50%2C0%2C1012%2C506&s=a9aaf8c43a7b678b01fcdbff2bda38e3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103222034%2F37045632812%2F1%2Foriginal.20200610-180232?auto=format%2Ccompress&q=75&sharp=10&s=3d195396db6126ad7fcbab93d0eb63de',
                        width: 1112,
                        height: 506,
                    },
                    crop_mask: {
                        width: 1012,
                        height: 506,
                        top_left: {
                            y: 0,
                            x: 50,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103222034',
                },
                timezone: 'America/New_York',
                id: '109020190324',
                tickets_url:
                    'https://www.eventbrite.com/e/community-unity-in-economics-tickets-109020190324',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28560595427',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '22:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/African american',
                        display_name: 'African american',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109020190324',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '1002 Commercial Dr',
                    venue_profile_id: null,
                    address: {
                        city: 'Tallahassee',
                        country: 'US',
                        region: 'FL',
                        longitude: '-84.29408319999999',
                        localized_address_display:
                            '1002 Commercial Drive, Tallahassee, FL 32310',
                        postal_code: '32310',
                        address_1: '1002 Commercial Drive',
                        latitude: '30.4333156',
                        localized_multi_line_address_display: [
                            '1002 Commercial Drive',
                            'Tallahassee, FL 32310',
                        ],
                        localized_area_display: 'Tallahassee, FL',
                    },
                    venue_profile_url: '',
                    id: '51171988',
                },
                series_id: null,
                image_id: '103222034',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51171988',
                checkout_flow: 'moflo',
                name: 'Community Unity in Economics',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/community-unity-in-economics-tickets-109020190324',
                hide_start_date: false,
                summary:
                    'In spite of everything going on we must express unity in a way that is constructive by celebrating our heritage and supporting blk business',
                is_online_event: false,
                eid: 'ekmcxmy',
                published: '2020-06-10T18:15:03Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'CHILDREN OF ATHENS PEACEFUL PROTEST | BLACK LIVES MATTER',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#756c72',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103225032%2F143781449832%2F1%2Foriginal.20200610-181834?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C748%2C374&s=94847d3267b7665bc22e098620486a23',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103225032%2F143781449832%2F1%2Foriginal.20200610-181834?auto=format%2Ccompress&q=75&sharp=10&s=e0ca225debeabe2a61095487ba593b64',
                        width: 749,
                        height: 462,
                    },
                    crop_mask: {
                        width: 748,
                        height: 374,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103225032',
                },
                timezone: 'America/New_York',
                id: '109026924466',
                tickets_url:
                    'https://www.eventbrite.com.au/e/children-of-athens-peaceful-protest-black-lives-matter-tickets-109026924466',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30476013148',
                hide_end_date: false,
                start_date: '2020-06-13',
                end_time: '12:00',
                _type: 'destination_event',
                end_date: '2020-06-13',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#love',
                        display_name: '#love',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#peace',
                        display_name: '#peace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#justice',
                        display_name: '#justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#thetimeisnow',
                        display_name: '#thetimeisnow',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#athensga',
                        display_name: '#athensga',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#childrenofathens',
                        display_name: '#childrenofathens',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#ourfuture',
                        display_name: '#ourfuture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#peacefulprotest',
                        display_name: '#peacefulprotest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#standunited',
                        display_name: '#standunited',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109026924466',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Chase Street Elementary School',
                    venue_profile_id: null,
                    address: {
                        city: 'Athens',
                        country: 'US',
                        region: 'GA',
                        longitude: '-83.3945459',
                        localized_address_display:
                            '757 North Chase Street, Athens, GA 30601',
                        postal_code: '30601',
                        address_1: '757 North Chase Street',
                        latitude: '33.9647646',
                        localized_multi_line_address_display: [
                            '757 North Chase Street',
                            'Athens, GA 30601',
                        ],
                        localized_area_display: 'Athens, GA',
                    },
                    venue_profile_url: '',
                    id: '51173364',
                },
                series_id: null,
                image_id: '103225032',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51173364',
                checkout_flow: 'moflo',
                name:
                    'CHILDREN OF ATHENS PEACEFUL PROTEST | BLACK LIVES MATTER',
                language: 'en-au',
                url:
                    'https://www.eventbrite.com.au/e/children-of-athens-peaceful-protest-black-lives-matter-tickets-109026924466',
                hide_start_date: false,
                summary:
                    'Children of Athens Peaceful March for Black Lives Matter',
                is_online_event: false,
                eid: 'ekmdbtw',
                published: '2020-06-10T18:48:16Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Celebrate Black | Juneteenth',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102460878%2F309169981852%2F1%2Foriginal.20200602-144752?w=494&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C12%2C494%2C247&s=8927eac534e94141bdc05529ede08aaa',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102460878%2F309169981852%2F1%2Foriginal.20200602-144752?auto=format%2Ccompress&q=75&sharp=10&s=fa361b193b04959d83a020e9ccd18008',
                        width: 495,
                        height: 384,
                    },
                    crop_mask: {
                        width: 494,
                        height: 247,
                        top_left: {
                            y: 12,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102460878',
                },
                timezone: 'America/New_York',
                id: '107705054718',
                tickets_url:
                    'https://www.eventbrite.com/e/celebrate-black-juneteenth-tickets-107705054718',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '27274529545',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#network',
                        display_name: '#network',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#trapademics',
                        display_name: '#trapademics',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenth #daytonabeach',
                        display_name: '#juneteenth #daytonabeach',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter #donate',
                        display_name: '#blacklivesmatter #donate',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107705054718',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Reed Canal Park',
                    venue_profile_id: null,
                    address: {
                        city: 'South Daytona',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.01573499999999',
                        localized_address_display:
                            '919 Reed Canal Road, South Daytona, FL 32119',
                        postal_code: '32119',
                        address_1: '919 Reed Canal Road',
                        latitude: '29.1536742',
                        localized_multi_line_address_display: [
                            '919 Reed Canal Road',
                            'South Daytona, FL 32119',
                        ],
                        localized_area_display: 'South Daytona, FL',
                    },
                    venue_profile_url: '',
                    id: '50968522',
                },
                series_id: null,
                image_id: '102460878',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '50968522',
                checkout_flow: 'moflo',
                name: 'Celebrate Black | Juneteenth |',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/celebrate-black-juneteenth-tickets-107705054718',
                hide_start_date: false,
                summary:
                    'Black Celebration . celebrating success , knowledge, togetherness and freedom .',
                is_online_event: false,
                eid: 'ekhxdkk',
                published: '2020-06-03T17:37:34Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'COMO for L.O.V.E.',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102994016%2F158562986327%2F1%2Foriginal.20200608-175432?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C60%2C1920%2C960&s=a6bb2bed7c8b71c03044d5d6dc9ae649',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102994016%2F158562986327%2F1%2Foriginal.20200608-175432?auto=format%2Ccompress&q=75&sharp=10&s=ff1c562cb12c2d43e92ed86a02a83a4b',
                        width: 1920,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1920,
                        height: 960,
                        top_left: {
                            y: 60,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102994016',
                },
                timezone: 'America/Chicago',
                id: '108503145830',
                tickets_url:
                    'https://www.eventbrite.com/e/como-for-love-tickets-108503145830',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30443390376',
                hide_end_date: false,
                start_date: '2020-06-30',
                end_time: '23:00',
                _type: 'destination_event',
                end_date: '2020-06-30',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108503145830',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '220 N 10th St',
                    venue_profile_id: null,
                    address: {
                        city: 'Columbia',
                        country: 'US',
                        region: 'MO',
                        longitude: '-92.3259755',
                        localized_address_display:
                            '220 North 10th Street, Columbia, MO 65201',
                        postal_code: '65201',
                        address_1: '220 North 10th Street',
                        latitude: '38.9541096',
                        localized_multi_line_address_display: [
                            '220 North 10th Street',
                            'Columbia, MO 65201',
                        ],
                        localized_area_display: 'Columbia, MO',
                    },
                    venue_profile_url: '',
                    id: '51052174',
                },
                series_id: null,
                image_id: '102994016',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51052174',
                checkout_flow: 'moflo',
                name: 'COMO for L.O.V.E.',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/como-for-love-tickets-108503145830',
                hide_start_date: false,
                summary:
                    'COMO for L.O.V.E. - Lifting Oppression Virtually Everywhere  - A benefit\nAn evening of music, food, art and LOVE for our black community.',
                is_online_event: false,
                eid: 'ekkkrmb',
                published: '2020-06-08T17:55:54Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Free(ish) : A Mindful Juneteenth Event',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102517528%2F49447866966%2F1%2Foriginal.20200603-031151?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C83%2C1080%2C540&s=b8c5803b328c377f1a5a4676de21be7e',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102517528%2F49447866966%2F1%2Foriginal.20200603-031151?auto=format%2Ccompress&q=75&sharp=10&s=eba01c5903dd85bf26e3b25dafd0c57f',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 83,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102517528',
                },
                timezone: 'America/New_York',
                id: '107778773212',
                tickets_url:
                    'https://www.eventbrite.com/e/freeish-a-mindful-juneteenth-event-tickets-107778773212',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '3093818184',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '16:30',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Mindfulness',
                        display_name: 'Mindfulness',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cybp',
                        display_name: 'Cybp',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107778773212',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Mt. Storm Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Cincinnati',
                        country: 'US',
                        region: 'OH',
                        longitude: '-84.5325383',
                        localized_address_display:
                            '700 Lafayette Avenue, Cincinnati, OH 45220',
                        postal_code: '45220',
                        address_1: '700 Lafayette Avenue',
                        latitude: '39.15501379999999',
                        localized_multi_line_address_display: [
                            '700 Lafayette Avenue',
                            'Cincinnati, OH 45220',
                        ],
                        localized_area_display: 'Cincinnati, OH',
                    },
                    venue_profile_url: '',
                    id: '50981352',
                },
                series_id: null,
                image_id: '102517528',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '50981352',
                checkout_flow: 'moflo',
                name: 'Free(ish) : A Mindful Juneteenth Event',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/freeish-a-mindful-juneteenth-event-tickets-107778773212',
                hide_start_date: false,
                summary:
                    'Join CYBP for our Annual Juneteenth  Celebration. Taking  time  to focus and discuss, community planning and mental health mindfulness.',
                is_online_event: false,
                eid: 'ekhytdk',
                published: '2020-06-09T22:36:16Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Houston Blackout - Juneteenth Support Black Business',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#4f3b20',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103264468%2F452479674338%2F1%2Foriginal.20200611-015457?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C798%2C399&s=8ba1d5c9dba3238dd2d0c176cf9b0d66',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103264468%2F452479674338%2F1%2Foriginal.20200611-015457?auto=format%2Ccompress&q=75&sharp=10&s=cb1326d823c064f1aee99bc862c8f948',
                        width: 798,
                        height: 800,
                    },
                    crop_mask: {
                        width: 798,
                        height: 399,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103264468',
                },
                timezone: 'America/Chicago',
                id: '109094374210',
                tickets_url:
                    'https://www.eventbrite.com/e/houston-blackout-juneteenth-support-black-business-tickets-109094374210',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30478858930',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/6001',
                        display_name: 'Fashion',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/106',
                        display_name: 'Fashion & Beauty',
                        localized: {
                            display_name: 'Fashion & Beauty',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Shopping',
                        display_name: 'Shopping',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fashion',
                        display_name: 'Fashion',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Houston',
                        display_name: 'Houston',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Local business',
                        display_name: 'Local business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black owned business',
                        display_name: 'Black owned business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Houston events',
                        display_name: 'Houston events',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Houston event',
                        display_name: 'Houston event',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Thrifts',
                        display_name: 'Thrifts',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Houston designers',
                        display_name: 'Houston designers',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109094374210',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Exchange To Change LLC',
                    venue_profile_id: null,
                    address: {
                        city: 'Houston',
                        country: 'US',
                        region: 'TX',
                        longitude: '-95.3558683',
                        localized_address_display:
                            '3801 North MacGregor Way, Houston, TX 77004',
                        postal_code: '77004',
                        address_1: '3801 North MacGregor Way',
                        latitude: '29.7104442',
                        localized_multi_line_address_display: [
                            '3801 North MacGregor Way',
                            'Houston, TX 77004',
                        ],
                        localized_area_display: 'Houston, TX',
                    },
                    venue_profile_url: '',
                    id: '51180576',
                },
                series_id: null,
                image_id: '103264468',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51180576',
                checkout_flow: 'moflo',
                name: 'Houston Blackout - Juneteenth Support Black Business',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/houston-blackout-juneteenth-support-black-business-tickets-109094374210',
                hide_start_date: false,
                summary:
                    'Happy Juneteenth!!!  Come Sip, Shop, & Share with us!  This is centered around celebrating Juneteenth & black businesses. Kid friendly.',
                is_online_event: false,
                eid: 'ekmdzmp',
                published: '2020-06-11T02:30:30Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'How to be Anti-Racist: A Community Workshop & Dialogue',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103229048%2F322328105451%2F1%2Foriginal.20200610-190453?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C41%2C3240%2C1620&s=000e5b71ccc61b93bdb4cff3ea6ef9a3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103229048%2F322328105451%2F1%2Foriginal.20200610-190453?auto=format%2Ccompress&q=75&sharp=10&s=66627dee622d8525f1b49231cc47c00d',
                        width: 3240,
                        height: 3240,
                    },
                    crop_mask: {
                        width: 3240,
                        height: 1620,
                        top_left: {
                            y: 41,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103229048',
                },
                timezone: 'America/Los_Angeles',
                id: '108927643514',
                tickets_url:
                    'https://www.eventbrite.com/e/how-to-be-anti-racist-a-community-workshop-dialogue-tickets-108927643514',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '25806526959',
                hide_end_date: false,
                start_date: '2020-06-17',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-17',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/2',
                        display_name: 'Seminar or Talk',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Workshop',
                        display_name: 'Workshop',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Dialogue',
                        display_name: 'Dialogue',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Antiracism',
                        display_name: 'Antiracism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Antiracist',
                        display_name: 'Antiracist',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Georgefloyd',
                        display_name: 'Georgefloyd',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Whiteallyship',
                        display_name: 'Whiteallyship',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108927643514',
                start_time: '18:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Chehalem Cultural Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Newberg',
                        country: 'US',
                        region: 'OR',
                        longitude: '-122.97513500000002',
                        localized_address_display:
                            '415 East Sheridan Street, Newberg, OR 97132',
                        postal_code: '97132',
                        address_1: '415 East Sheridan Street',
                        latitude: '45.3023224',
                        localized_multi_line_address_display: [
                            '415 East Sheridan Street',
                            'Newberg, OR 97132',
                        ],
                        localized_area_display: 'Newberg, OR',
                    },
                    venue_profile_url: '',
                    id: '51149618',
                },
                series_id: null,
                image_id: '103229048',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51149618',
                checkout_flow: 'moflo',
                name: 'How to be Anti-Racist: A Community Workshop & Dialogue',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/how-to-be-anti-racist-a-community-workshop-dialogue-tickets-108927643514',
                hide_start_date: false,
                summary:
                    'In response to the death of George Floyd, the CCC invites the community to engage in  a series of workshops on "How to be Anti-Racist."',
                is_online_event: false,
                eid: 'ekkzrrp',
                published: '2020-06-11T17:24:37Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: "I Have A Voice Too! Kids' Protest",
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103095898%2F71712444629%2F1%2Foriginal.20200609-160737?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C12%2C960%2C480&s=32e8d2b68d6f19463167eec4fc14a4e1',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103095898%2F71712444629%2F1%2Foriginal.20200609-160737?auto=format%2Ccompress&q=75&sharp=10&s=d8c6e989e657df9be1d794211423fd72',
                        width: 960,
                        height: 502,
                    },
                    crop_mask: {
                        width: 960,
                        height: 480,
                        top_left: {
                            y: 12,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103095898',
                },
                timezone: 'America/Chicago',
                id: '108879066218',
                tickets_url:
                    'https://www.eventbrite.com/e/i-have-a-voice-too-kids-protest-tickets-108879066218',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30465951204',
                hide_end_date: false,
                start_date: '2020-06-27',
                end_time: '12:00',
                _type: 'destination_event',
                end_date: '2020-06-27',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Family',
                        display_name: 'Family',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Child friendly',
                        display_name: 'Child friendly',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108879066218',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Mountain Creek Lake Park Pavilion',
                    venue_profile_id: null,
                    address: {
                        city: 'Grand Prairie',
                        country: 'US',
                        region: 'TX',
                        longitude: '-96.97853889999999',
                        localized_address_display:
                            '2402 Cardiff Street, Grand Prairie, TX 75051',
                        postal_code: '75051',
                        address_1: '2402 Cardiff Street',
                        latitude: '32.7130377',
                        localized_multi_line_address_display: [
                            '2402 Cardiff Street',
                            'Grand Prairie, TX 75051',
                        ],
                        localized_area_display: 'Grand Prairie, TX',
                    },
                    venue_profile_url: '',
                    id: '51139386',
                },
                series_id: null,
                image_id: '103095898',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51139386',
                checkout_flow: 'moflo',
                name: "I Have A Voice Too! Kids' Protest",
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/i-have-a-voice-too-kids-protest-tickets-108879066218',
                hide_start_date: false,
                summary:
                    'Our children have heard us talking and now can lead us marching!',
                is_online_event: false,
                eid: 'ekkymtd',
                published: '2020-06-09T16:12:30Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Inaugural Unified Juneteenth " Social Distance" Celebration Caravan',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103124490%2F249238348656%2F1%2Foriginal.20200609-202509?w=282&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C1%2C282%2C141&s=9d9471712255241b97f6220d9fdb8df8',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103124490%2F249238348656%2F1%2Foriginal.20200609-202509?auto=format%2Ccompress&q=75&sharp=10&s=83d665f0e4e819e7a5a2758850632832',
                        width: 282,
                        height: 179,
                    },
                    crop_mask: {
                        width: 282,
                        height: 141,
                        top_left: {
                            y: 1,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103124490',
                },
                timezone: 'America/Chicago',
                id: '108907665760',
                tickets_url:
                    'https://www.eventbrite.com/e/inaugural-social-distance-juneteenth-caravan-tickets-108907665760',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17089616747',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '13:30',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Celebration',
                        display_name: 'Celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Covid19',
                        display_name: 'Covid19',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Social distancing',
                        display_name: 'Social distancing',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth culture',
                        display_name: 'Juneteenth culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cadav community',
                        display_name: 'Cadav community',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108907665760',
                start_time: '11:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Memorial Stadium',
                    venue_profile_id: null,
                    address: {
                        city: 'Baton Rouge',
                        country: 'US',
                        region: 'LA',
                        longitude: '-91.17125999999999',
                        localized_address_display:
                            '1750 Foss Street, Baton Rouge, LA 70802',
                        postal_code: '70802',
                        address_1: '1750 Foss Street',
                        latitude: '30.4590024',
                        localized_multi_line_address_display: [
                            '1750 Foss Street',
                            'Baton Rouge, LA 70802',
                        ],
                        localized_area_display: 'Baton Rouge, LA',
                    },
                    venue_profile_url: '',
                    id: '51145178',
                },
                series_id: null,
                image_id: '103124490',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51145178',
                checkout_flow: 'moflo',
                name: 'Inaugural  " Social Distance" Juneteenth Caravan',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/inaugural-social-distance-juneteenth-caravan-tickets-108907665760',
                hide_start_date: false,
                summary:
                    'Juneteenth is the annual commemoration of June 19, 1865, when the abolition of slavery was announced in Texas  two years after the fact.',
                is_online_event: false,
                eid: 'ekkzdtg',
                published: '2020-06-10T01:28:34Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth at the Factory',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#8a8a8a',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102618958%2F272081979515%2F1%2Foriginal.20200603-211732?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C128%2C512%2C256&s=3f3f0abb7673ab735ac861b9bd70e158',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102618958%2F272081979515%2F1%2Foriginal.20200603-211732?auto=format%2Ccompress&q=75&sharp=10&s=ebc9fb9c50e7155f4315bd974a2a1f52',
                        width: 512,
                        height: 512,
                    },
                    crop_mask: {
                        width: 512,
                        height: 256,
                        top_left: {
                            y: 128,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102618958',
                },
                timezone: 'America/New_York',
                id: '108034574320',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-factory-candle-light-4-george-floyd-tickets-108034574320',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30266931752',
                hide_end_date: true,
                start_date: '2020-07-19',
                end_time: '21:00',
                _type: 'destination_event',
                end_date: '2020-07-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/7',
                        display_name: 'Screening',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Movie',
                        display_name: 'Movie',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Candle light',
                        display_name: 'Candle light',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/The hate u give',
                        display_name: 'The hate u give',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Trayvon martin',
                        display_name: 'Trayvon martin',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/George floyd',
                        display_name: 'George floyd',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Us or them',
                        display_name: 'Us or them',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/12factory studios',
                        display_name: '12factory studios',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Djdesignerkidd',
                        display_name: 'Djdesignerkidd',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108034574320',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '2646 Church Dr',
                    venue_profile_id: null,
                    address: {
                        city: 'Atlanta',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.2785059',
                        localized_address_display:
                            '2646 Church Drive, Atlanta, GA 30340',
                        postal_code: '30340',
                        address_1: '2646 Church Drive',
                        latitude: '33.90283399999999',
                        localized_multi_line_address_display: [
                            '2646 Church Drive',
                            'Atlanta, GA 30340',
                        ],
                        localized_area_display: 'Atlanta, GA',
                    },
                    venue_profile_url: '',
                    id: '51000704',
                },
                series_id: null,
                image_id: '102618958',
                is_cancelled: null,
                primary_venue_id: '51000704',
                checkout_flow: 'moflo',
                name: 'Juneteenth At The Factory (Candle Light 4 George Floyd)',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-factory-candle-light-4-george-floyd-tickets-108034574320',
                hide_start_date: false,
                summary:
                    'As a Community we as African Americans are tired of the police taking one of our own. To Commemorate lives taken we are hosting Candle light',
                is_online_event: false,
                eid: 'ekkcbhy',
                published: '2020-06-03T23:27:58Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth at the PARC',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102959300%2F305553657550%2F1%2Foriginal.20200608-124502?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C247%2C642%2C321&s=4488f768cffa1510654b3210a440e102',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102959300%2F305553657550%2F1%2Foriginal.20200608-124502?auto=format%2Ccompress&q=75&sharp=10&s=a5191405649719167da009866ac6ab3f',
                        width: 643,
                        height: 675,
                    },
                    crop_mask: {
                        width: 642,
                        height: 321,
                        top_left: {
                            y: 247,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102959300',
                },
                timezone: 'America/Detroit',
                id: '108688327714',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-parc-tickets-108688327714',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '20155849173',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Vendors',
                        display_name: 'Vendors',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Detroit',
                        display_name: 'Detroit',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Vendor',
                        display_name: 'Vendor',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Smallbusinesses',
                        display_name: 'Smallbusinesses',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Shopblack',
                        display_name: 'Shopblack',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108688327714',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '10329 W McNichols Rd',
                    venue_profile_id: null,
                    address: {
                        city: 'Detroit',
                        country: 'US',
                        region: 'MI',
                        longitude: '-83.16416960000004',
                        localized_address_display:
                            '10329 West McNichols Road, Detroit, MI 48221',
                        postal_code: '48221',
                        address_1: '10329 West McNichols Road',
                        latitude: '42.4165637',
                        localized_multi_line_address_display: [
                            '10329 West McNichols Road',
                            'Detroit, MI 48221',
                        ],
                        localized_area_display: 'Detroit, MI',
                    },
                    venue_profile_url: '',
                    id: '51106208',
                },
                series_id: null,
                image_id: '102959300',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51106208',
                checkout_flow: 'moflo',
                name: 'Juneteenth at the PARC',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-parc-tickets-108688327714',
                hide_start_date: false,
                summary:
                    'The 2nd Annual Juneteenth at the PARC is an annual celebration of heritage, culture, history and entrepreneurs in the city of Detroit.',
                is_online_event: false,
                eid: 'ekkrrqy',
                published: '2020-06-08T12:56:04Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Black Business Expo',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#6f635f',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102919668%2F253425157591%2F1%2Foriginal.20200607-221736?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C16%2C2048%2C1024&s=de6783e5bd603a21fdc21eb6ecc748ad',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102919668%2F253425157591%2F1%2Foriginal.20200607-221736?auto=format%2Ccompress&q=75&sharp=10&s=3be320d07f64f3d80fe74d3311bfb49f',
                        width: 2048,
                        height: 1536,
                    },
                    crop_mask: {
                        width: 2048,
                        height: 1024,
                        top_left: {
                            y: 16,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102919668',
                },
                timezone: 'America/Chicago',
                id: '108637006210',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-black-business-expo-tickets-108637006210',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30451579300',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black business',
                        display_name: 'Black business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pensacola',
                        display_name: 'Pensacola',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108637006210',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'The Neighborhood Ice cream Parlor',
                    venue_profile_id: null,
                    address: {
                        city: 'Pensacola',
                        country: 'US',
                        region: 'FL',
                        longitude: '-87.2755786',
                        localized_address_display:
                            "120 Chief's Way, Pensacola, FL 32507",
                        postal_code: '32507',
                        address_1: "120 Chief's Way",
                        latitude: '30.4082364',
                        localized_multi_line_address_display: [
                            "120 Chief's Way",
                            'Pensacola, FL 32507',
                        ],
                        localized_area_display: 'Pensacola, FL',
                    },
                    venue_profile_url: '',
                    id: '51093690',
                },
                series_id: null,
                image_id: '102919668',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51093690',
                checkout_flow: 'moflo',
                name: 'Juneteenth Black Business Expo',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-black-business-expo-tickets-108637006210',
                hide_start_date: false,
                summary: 'Come out to Learn and Celebrate Juneteenth!',
                is_online_event: false,
                eid: 'ekkqkzw',
                published: '2020-06-07T22:23:56Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Celebration for the Culture',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#fcfdfa',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103192862%2F216309217046%2F1%2Foriginal.20200610-135752?w=306&auto=format%2Ccompress&q=75&sharp=10&rect=12%2C0%2C306%2C153&s=44301aa6e8a275faf846d22c7c21f067',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103192862%2F216309217046%2F1%2Foriginal.20200610-135752?auto=format%2Ccompress&q=75&sharp=10&s=f26367c460c67ecbd62ab8dc58305226',
                        width: 330,
                        height: 153,
                    },
                    crop_mask: {
                        width: 306,
                        height: 153,
                        top_left: {
                            y: 0,
                            x: 12,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103192862',
                },
                timezone: 'America/New_York',
                id: '108992483452',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-for-the-culture-tickets-108992483452',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30473332514',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#family #love #fun #park',
                        display_name: '#family #love #fun #park',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklove #blackfamlies',
                        display_name: '#blacklove #blackfamlies',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#fathersdayweekend',
                        display_name: '#fathersdayweekend',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#love #peace #unity #hope',
                        display_name: '#love #peace #unity #hope',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108992483452',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'West Harlem Piers',
                    venue_profile_id: null,
                    address: {
                        city: 'New York',
                        country: 'US',
                        region: 'NY',
                        longitude: '-73.9610999',
                        localized_address_display:
                            'West 132nd Street, New York, NY 10027',
                        postal_code: '10027',
                        address_1: 'West 132nd Street',
                        latitude: '40.8194924',
                        localized_multi_line_address_display: [
                            'West 132nd Street',
                            'New York, NY 10027',
                        ],
                        localized_area_display: 'New York, NY',
                    },
                    venue_profile_url: '',
                    id: '51166282',
                },
                series_id: null,
                image_id: '103192862',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51166282',
                checkout_flow: 'moflo',
                name: 'Juneteenth Celebration for the Culture',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-for-the-culture-tickets-108992483452',
                hide_start_date: false,
                summary:
                    'Lets us come together in solidarity to celebrate the culture.  125th St ENTRANCE',
                is_online_event: false,
                eid: 'ekmcdpd',
                published: '2020-06-10T14:15:26Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Juneteenth Celebration & Social Justice "Pull Up" Rally',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103337578%2F35605151536%2F1%2Foriginal.20200611-181356?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=10%2C0%2C2160%2C1080&s=ed83de9782101d5d2e7102d9d490654d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103337578%2F35605151536%2F1%2Foriginal.20200611-181356?auto=format%2Ccompress&q=75&sharp=10&s=c5c6267f219946da21279b1168959ad9',
                        width: 2180,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 10,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103337578',
                },
                timezone: 'America/Chicago',
                id: '108855355298',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-social-justice-pull-up-rally-tickets-108855355298',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30484508200',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community',
                        display_name: 'Community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Justice',
                        display_name: 'Justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Advocacy',
                        display_name: 'Advocacy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Austin, texas',
                        display_name: 'Austin, texas',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108855355298',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Millennium Youth Entertainment Complex',
                    venue_profile_id: null,
                    address: {
                        city: 'Austin',
                        country: 'US',
                        region: 'TX',
                        longitude: '-97.7107387',
                        localized_address_display:
                            '1156 Hargrave Street, Austin, TX 78702',
                        postal_code: '78702',
                        address_1: '1156 Hargrave Street',
                        latitude: '30.2717027',
                        localized_multi_line_address_display: [
                            '1156 Hargrave Street',
                            'Austin, TX 78702',
                        ],
                        localized_area_display: 'Austin, TX',
                    },
                    venue_profile_url: '',
                    id: '51137840',
                },
                series_id: null,
                image_id: '103337578',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51137840',
                checkout_flow: 'moflo',
                name: 'Juneteenth Celebration & Social Justice "Pull Up" Rally',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-social-justice-pull-up-rally-tickets-108855355298',
                hide_start_date: false,
                summary:
                    'More Than A Moment. Let’s Make It A Movement. Join us on 6.20.2020 for our Juneteenth Celebration & Social Justice “Pull Up" Rally!',
                is_online_event: false,
                eid: 'ekkxzcr',
                published: '2020-06-09T13:59:54Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Event',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95556755%2F424271561135%2F1%2Foriginal.20200305-175955?w=300&auto=format%2Ccompress&q=75&sharp=10&rect=100%2C0%2C300%2C150&s=4aa8b2158d7ff8263d7237c82c1c9676',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95556755%2F424271561135%2F1%2Foriginal.20200305-175955?auto=format%2Ccompress&q=75&sharp=10&s=a63a6e8305ff4ef640e6f171d2de20e2',
                        width: 500,
                        height: 150,
                    },
                    crop_mask: {
                        width: 300,
                        height: 150,
                        top_left: {
                            y: 0,
                            x: 100,
                        },
                    },
                    aspect_ratio: '2',
                    id: '95556755',
                },
                timezone: 'America/Los_Angeles',
                id: '98441066881',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-event-tickets-98441066881',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29892781909',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11008',
                        display_name: 'Education',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cycling',
                        display_name: 'Cycling',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community bike ride',
                        display_name: 'Community bike ride',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Major taylor',
                        display_name: 'Major taylor',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth los angeles',
                        display_name: 'Juneteenth los angeles',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/(njof) national juneteen',
                        display_name: '(njof) national juneteen',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Colonel young',
                        display_name: 'Colonel young',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '98441066881',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Leimert Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Los Angeles',
                        country: 'US',
                        region: 'CA',
                        longitude: '-118.33179',
                        localized_address_display:
                            '4337 Degnan Blvd , Los Angeles, CA 90008',
                        postal_code: '90008',
                        address_1: '4337 Degnan Blvd ',
                        latitude: '34.004767',
                        localized_multi_line_address_display: [
                            '4337 Degnan Blvd',
                            'Los Angeles, CA 90008',
                        ],
                        localized_area_display: 'Los Angeles, CA',
                    },
                    venue_profile_url: '',
                    id: '49194145',
                },
                series_id: null,
                image_id: '95556755',
                is_cancelled: null,
                primary_venue_id: '49194145',
                checkout_flow: 'moflo',
                name: 'Juneteenth Event',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-event-tickets-98441066881',
                hide_start_date: false,
                summary:
                    'Juneteenth Los Angeles 2020 - Three Days of Festivities',
                is_online_event: false,
                eid: 'ehtzxkk',
                published: '2020-03-05T20:20:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth March for Justice',
            event: {
                timezone: 'America/Detroit',
                id: '109145605444',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-march-for-justice-tickets-109145605444',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17940881176',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/199',
                        display_name: 'Other',
                        localized: {
                            display_name: 'Other',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                ],
                eventbrite_event_id: '109145605444',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Dearborn Police Department',
                    venue_profile_id: null,
                    address: {
                        city: 'Dearborn',
                        country: 'US',
                        region: 'MI',
                        longitude: '-83.2004144',
                        localized_address_display:
                            '16099 Michigan Avenue, Dearborn, MI 48126',
                        postal_code: '48126',
                        address_1: '16099 Michigan Avenue',
                        latitude: '42.314071',
                        localized_multi_line_address_display: [
                            '16099 Michigan Avenue',
                            'Dearborn, MI 48126',
                        ],
                        localized_area_display: 'Dearborn, MI',
                    },
                    venue_profile_url: '',
                    id: '51192742',
                },
                series_id: null,
                image_id: null,
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51192742',
                checkout_flow: 'moflo',
                name: 'Juneteenth March for Justice',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-march-for-justice-tickets-109145605444',
                hide_start_date: false,
                summary: 'Juneteenth March for Justice',
                is_online_event: false,
                eid: '109145605444',
                published: '2020-06-11T12:36:15Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Juneteenth: A Celebration presented by The Melanin Market',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#776b50',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103342280%2F52618686412%2F1%2Foriginal.jpg?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C62%2C1080%2C540&s=14250e83db1abd1e36130b16939aec3e',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103342280%2F52618686412%2F1%2Foriginal.jpg?auto=format%2Ccompress&q=75&sharp=10&s=f20abecfac10a0df1bff972ecb48238e',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 62,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103342280',
                },
                timezone: 'America/New_York',
                id: '109198082404',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-a-celebration-presented-by-the-melanin-market-tickets-109198082404',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18193152802',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#freedom',
                        display_name: '#freedom',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenth',
                        display_name: '#juneteenth',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109198082404',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '4819 Soutel Dr',
                    venue_profile_id: null,
                    address: {
                        city: 'Jacksonville',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.72393699999999',
                        localized_address_display:
                            '4819 Soutel Drive, Jacksonville, FL 32208',
                        postal_code: '32208',
                        address_1: '4819 Soutel Drive',
                        latitude: '30.40203899999999',
                        localized_multi_line_address_display: [
                            '4819 Soutel Drive',
                            'Jacksonville, FL 32208',
                        ],
                        localized_area_display: 'Jacksonville, FL',
                    },
                    venue_profile_url: '',
                    id: '29788038',
                },
                series_id: null,
                image_id: '103342280',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '29788038',
                checkout_flow: 'moflo',
                name:
                    'Juneteenth: A Celebration presented by The Melanin Market',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-a-celebration-presented-by-the-melanin-market-tickets-109198082404',
                hide_start_date: false,
                summary:
                    'Come celebrate the Black Independence Day and learn the history of Juneteenth.',
                is_online_event: false,
                eid: 'ekmhdkb',
                published: '2020-06-11T18:59:36Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Yoga & Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#57697c',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102925226%2F282157145425%2F1%2Foriginal.20200608-005718?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C80%2C620%2C310&s=401a71089c993e3980d17d2835d89cb5',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102925226%2F282157145425%2F1%2Foriginal.20200608-005718?auto=format%2Ccompress&q=75&sharp=10&s=9b0612505a6f1a2606fbac64544adca5',
                        width: 620,
                        height: 420,
                    },
                    crop_mask: {
                        width: 620,
                        height: 310,
                        top_left: {
                            y: 80,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102925226',
                },
                timezone: 'America/New_York',
                id: '108642769448',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-yoga-celebration-tickets-108642769448',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18164808773',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/107',
                        display_name: 'Health & Wellness',
                        localized: {
                            display_name: 'Health & Wellness',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Yoga',
                        display_name: 'Yoga',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Networking',
                        display_name: 'Networking',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black business',
                        display_name: 'Black business',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108642769448',
                start_time: '18:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '1Raw Yoga and Natural Products',
                    venue_profile_id: null,
                    address: {
                        city: 'Sanford',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.26456',
                        localized_address_display:
                            '541 N. Palmetto Ave. Suite 102, Sanford, FL 32771',
                        postal_code: '32771',
                        address_1: '541 N. Palmetto Ave. Suite 102',
                        latitude: '28.81623',
                        localized_multi_line_address_display: [
                            '541 N. Palmetto Ave. Suite 102',
                            'Sanford, FL 32771',
                        ],
                        localized_area_display: 'Sanford, FL',
                    },
                    venue_profile_url: '',
                    id: '51094464',
                },
                series_id: null,
                image_id: '102925226',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51094464',
                checkout_flow: 'moflo',
                name: 'Juneteenth Yoga & Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-yoga-celebration-tickets-108642769448',
                hide_start_date: false,
                summary: 'Join us for a peaceful celebration of Juneteenth',
                is_online_event: false,
                eid: 'ekkqqrk',
                published: '2020-06-08T00:57:28Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Living In Color! A Juneteenth & Pride Month celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#b9bfa0',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103234754%2F375221898221%2F1%2Foriginal.20200610-195857?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C280%2C1124%2C562&s=e2289061521a345f174318b3a3a756c6',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103234754%2F375221898221%2F1%2Foriginal.20200610-195857?auto=format%2Ccompress&q=75&sharp=10&s=36abbfde28423d2d5556d0a1335e706f',
                        width: 1125,
                        height: 1461,
                    },
                    crop_mask: {
                        width: 1124,
                        height: 562,
                        top_left: {
                            y: 280,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103234754',
                },
                timezone: 'America/New_York',
                id: '109003285762',
                tickets_url:
                    'https://www.eventbrite.com/e/living-in-color-a-juneteenth-pride-month-celebration-tickets-109003285762',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28861861631',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Free',
                        display_name: 'Free',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fun',
                        display_name: 'Fun',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Lgbtq',
                        display_name: 'Lgbtq',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Free food',
                        display_name: 'Free food',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black pride',
                        display_name: 'Black pride',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Pride month',
                        display_name: 'Pride month',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Tie-die',
                        display_name: 'Tie-die',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109003285762',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '5206 N Pearl St',
                    venue_profile_id: null,
                    address: {
                        city: 'Jacksonville',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.6567512',
                        localized_address_display:
                            '5206 North Pearl Street, Jacksonville, FL 32208',
                        postal_code: '32208',
                        address_1: '5206 North Pearl Street',
                        latitude: '30.3712361',
                        localized_multi_line_address_display: [
                            '5206 North Pearl Street',
                            'Jacksonville, FL 32208',
                        ],
                        localized_area_display: 'Jacksonville, FL',
                    },
                    venue_profile_url: '',
                    id: '51168656',
                },
                series_id: null,
                image_id: '103234754',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51168656',
                checkout_flow: 'moflo',
                name: 'Living In Color! A Juneteenth & Pride Month celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/living-in-color-a-juneteenth-pride-month-celebration-tickets-109003285762',
                hide_start_date: false,
                summary:
                    'This event will be a Pride month and Juneteenth celebration!',
                is_online_event: false,
                eid: 'ekmcmbw',
                published: '2020-06-10T15:52:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Morals + Murals- Tales from Our Hood Experience',
            event: {
                timezone: 'America/New_York',
                id: '108837536000',
                tickets_url:
                    'https://www.eventbrite.com/e/morals-murals-tales-from-our-hood-experience-tickets-108837536000',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '15952526445',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/16',
                        display_name: 'Tour',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Experience',
                        display_name: 'Experience',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Walking tour',
                        display_name: 'Walking tour',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Day trip',
                        display_name: 'Day trip',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hood tour',
                        display_name: 'Hood tour',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black tour',
                        display_name: 'Black tour',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108837536000',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Dilworth Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Philadelphia',
                        country: 'US',
                        region: 'PA',
                        longitude: '-75.16620219999999',
                        localized_address_display:
                            '1500 Market Street, Philadelphia, PA 19107',
                        postal_code: '19107',
                        address_1: '1500 Market Street',
                        latitude: '39.9522839',
                        localized_multi_line_address_display: [
                            '1500 Market Street',
                            'Philadelphia, PA 19107',
                        ],
                        localized_area_display: 'Philadelphia, PA',
                    },
                    venue_profile_url: '',
                    id: '51131136',
                },
                series_id: null,
                image_id: null,
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51131136',
                checkout_flow: 'moflo',
                name: 'Morals + Murals- Tales from Our Hood Experience',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/morals-murals-tales-from-our-hood-experience-tickets-108837536000',
                hide_start_date: false,
                summary:
                    'The human to human experience provides a safe place to speak on racism, injustices, trauma and hope.',
                is_online_event: false,
                eid: 'ekkxprk',
                published: '2020-06-09T12:02:19Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'March for Justice',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#e01d23',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103109844%2F302213050855%2F1%2Foriginal.20200609-180945?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=11%2C328%2C732%2C366&s=de0070cb539ec33baa8eedf05791359d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103109844%2F302213050855%2F1%2Foriginal.20200609-180945?auto=format%2Ccompress&q=75&sharp=10&s=dbbb774af6bdc3587dfc7b38234c084c',
                        width: 750,
                        height: 1004,
                    },
                    crop_mask: {
                        width: 732,
                        height: 366,
                        top_left: {
                            y: 328,
                            x: 11,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103109844',
                },
                timezone: 'America/New_York',
                id: '108896837372',
                tickets_url:
                    'https://www.eventbrite.com/e/march-for-justice-tickets-108896837372',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30418930346',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '17:30',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Justice',
                        display_name: 'Justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Delaware',
                        display_name: 'Delaware',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Dover',
                        display_name: 'Dover',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/March',
                        display_name: 'March',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Acab',
                        display_name: 'Acab',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108896837372',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'John Wesley AME Church',
                    venue_profile_id: null,
                    address: {
                        city: 'Dover',
                        country: 'US',
                        region: 'DE',
                        longitude: '-75.52905299999999',
                        localized_address_display:
                            '217 West Division Street, Dover, DE 19904',
                        postal_code: '19904',
                        address_1: '217 West Division Street',
                        latitude: '39.161154',
                        localized_multi_line_address_display: [
                            '217 West Division Street',
                            'Dover, DE 19904',
                        ],
                        localized_area_display: 'Dover, DE',
                    },
                    venue_profile_url: '',
                    id: '51142532',
                },
                series_id: null,
                image_id: '103109844',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51142532',
                checkout_flow: 'moflo',
                name: 'March for Justice',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/march-for-justice-tickets-108896837372',
                hide_start_date: false,
                summary:
                    'A March Towards Justice across Dover Delaware welcome to members of the community of all ages in support of the Black Lives Matter movement',
                is_online_event: false,
                eid: 'ekkyxzp',
                published: '2020-06-09T18:22:59Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Smyrna Youth Rally for Social Justice',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#3e3c3b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102994454%2F252697477237%2F1%2Foriginal.20200608-175819?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C0%2C790%2C395&s=081510ad876e2993411e2f2fca533dc9',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102994454%2F252697477237%2F1%2Foriginal.20200608-175819?auto=format%2Ccompress&q=75&sharp=10&s=7b89c88460d064294bad5817221fb553',
                        width: 791,
                        height: 1024,
                    },
                    crop_mask: {
                        width: 790,
                        height: 395,
                        top_left: {
                            y: 0,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102994454',
                },
                timezone: 'America/New_York',
                id: '108752543786',
                tickets_url:
                    'https://www.eventbrite.com/e/smyrna-youth-rally-for-social-justice-tickets-108752543786',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30456817714',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '17:30',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Activism',
                        display_name: 'Activism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Smyrna',
                        display_name: 'Smyrna',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Social justice',
                        display_name: 'Social justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Allyship',
                        display_name: 'Allyship',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Youth activism',
                        display_name: 'Youth activism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108752543786',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Taylor-Brawner Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Smyrna',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.506812',
                        localized_address_display:
                            '3180 Atlanta Road Southeast, Smyrna, GA 30080',
                        postal_code: '30080',
                        address_1: '3180 Atlanta Road Southeast',
                        latitude: '33.8754862',
                        localized_multi_line_address_display: [
                            '3180 Atlanta Road Southeast',
                            'Smyrna, GA 30080',
                        ],
                        localized_area_display: 'Smyrna, GA',
                    },
                    venue_profile_url: '',
                    id: '51114642',
                },
                series_id: null,
                image_id: '102994454',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51114642',
                checkout_flow: 'moflo',
                name: 'Smyrna Youth Rally for Social Justice',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/smyrna-youth-rally-for-social-justice-tickets-108752543786',
                hide_start_date: false,
                summary:
                    'Youth rally focused on discussion and organizing. Features youth speakers, voter registration & informational resources will be available.',
                is_online_event: false,
                eid: 'ekktrgb',
                published: '2020-06-08T18:01:12Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Smyrna Social Justice March',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#d2d2d2',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102993046%2F252697477237%2F1%2Foriginal.20200608-174556?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=103%2C80%2C582%2C291&s=6695f82d8d2ac30a1561917ab1024e89',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102993046%2F252697477237%2F1%2Foriginal.20200608-174556?auto=format%2Ccompress&q=75&sharp=10&s=c491fa091bb57d8f86fb3f26bdbb8939',
                        width: 818,
                        height: 1061,
                    },
                    crop_mask: {
                        width: 582,
                        height: 291,
                        top_left: {
                            y: 80,
                            x: 103,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102993046',
                },
                timezone: 'America/New_York',
                id: '108751629050',
                tickets_url:
                    'https://www.eventbrite.com/e/smyrna-social-justice-march-tickets-108751629050',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30456817714',
                hide_end_date: false,
                start_date: '2020-06-13',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-13',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Activism',
                        display_name: 'Activism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Smyrna',
                        display_name: 'Smyrna',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Social justice',
                        display_name: 'Social justice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Youth activism',
                        display_name: 'Youth activism',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108751629050',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Campbell Middle School',
                    venue_profile_id: null,
                    address: {
                        city: 'Smyrna',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.49779149999999',
                        localized_address_display:
                            '3295 Atlanta Road Southeast, Smyrna, GA 30080',
                        postal_code: '30080',
                        address_1: '3295 Atlanta Road Southeast',
                        latitude: '33.872881',
                        localized_multi_line_address_display: [
                            '3295 Atlanta Road Southeast',
                            'Smyrna, GA 30080',
                        ],
                        localized_area_display: 'Smyrna, GA',
                    },
                    venue_profile_url: '',
                    id: '51114350',
                },
                series_id: null,
                image_id: '102993046',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51114350',
                checkout_flow: 'moflo',
                name: 'Smyrna Social Justice March',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/smyrna-social-justice-march-tickets-108751629050',
                hide_start_date: false,
                summary:
                    'Join us for a peaceful march for change & justice in our nation & state. \nJustice for #toomanyhashtags.',
                is_online_event: false,
                eid: 'ekktqty',
                published: '2020-06-08T17:49:54Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Soul Sista Presents: Juneteenth Show',
            event: {
                timezone: 'America/Los_Angeles',
                id: '98487740483',
                tickets_url:
                    'https://www.eventbrite.com/e/soul-sista-presents-juneteenth-show-tickets-98487740483',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '19858013818',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '21:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/5010',
                        display_name: 'Comedy',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/105',
                        display_name: 'Performing & Visual Arts',
                        localized: {
                            display_name: 'Performing & Visual Arts',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/6',
                        display_name: 'Concert or Performance',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Comedy',
                        display_name: 'Comedy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Losangeles',
                        display_name: 'Losangeles',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Funny',
                        display_name: 'Funny',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hollywood',
                        display_name: 'Hollywood',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Livecomedy',
                        display_name: 'Livecomedy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Soulsistacomedy',
                        display_name: 'Soulsistacomedy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blackcomedy',
                        display_name: 'Blackcomedy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blackandfunny',
                        display_name: 'Blackandfunny',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Lovecomedy',
                        display_name: 'Lovecomedy',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '98487740483',
                start_time: '20:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'The Pack Theater',
                    venue_profile_id: null,
                    address: {
                        city: 'Los Angeles',
                        country: 'US',
                        region: 'CA',
                        longitude: '-118.330623',
                        localized_address_display:
                            '6470 Santa Monica Boulevard, Los Angeles, CA 90038',
                        postal_code: '90038',
                        address_1: '6470 Santa Monica Boulevard',
                        latitude: '34.09053400000001',
                        localized_multi_line_address_display: [
                            '6470 Santa Monica Boulevard',
                            'Los Angeles, CA 90038',
                        ],
                        localized_area_display: 'Los Angeles, CA',
                    },
                    venue_profile_url: '',
                    id: '49210281',
                },
                series_id: null,
                image_id: null,
                is_cancelled: null,
                primary_venue_id: '49210281',
                checkout_flow: 'moflo',
                name: 'Soul Sista Presents: Juneteenth Show',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/soul-sista-presents-juneteenth-show-tickets-98487740483',
                hide_start_date: false,
                summary:
                    'Juneteenth, also known as Freedom Day or Juneteenth independence day, is an American holiday that commemorates the June 19, 1865.',
                is_online_event: false,
                eid: 'ehwbtdw',
                published: '2020-03-05T21:32:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Pre-Black Lives Matter March Solidarity Run',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103002452%2F52179231612%2F1%2Foriginal.20200608-190934?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C30%2C960%2C480&s=23692e826f3c51f82ade7e09535cb2cc',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103002452%2F52179231612%2F1%2Foriginal.20200608-190934?auto=format%2Ccompress&q=75&sharp=10&s=5bc92d9372909db942ffa7f1391bce3b',
                        width: 960,
                        height: 540,
                    },
                    crop_mask: {
                        width: 960,
                        height: 480,
                        top_left: {
                            y: 30,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103002452',
                },
                timezone: 'America/Los_Angeles',
                id: '108762469474',
                tickets_url:
                    'https://www.eventbrite.com/e/pre-black-lives-matter-march-solidarity-run-tickets-108762469474',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '3247240676',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [],
                eventbrite_event_id: '108762469474',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'South Lake Union',
                    venue_profile_id: null,
                    address: {
                        city: 'South Lake Union',
                        country: 'US',
                        region: 'WA',
                        longitude: '-122.335117',
                        localized_address_display: 'South Lake Union, WA 98109',
                        postal_code: '98109',
                        latitude: '47.62472',
                        localized_multi_line_address_display: [
                            'South Lake Union, WA 98109',
                        ],
                        localized_area_display: 'South Lake Union, WA',
                    },
                    venue_profile_url: '',
                    id: '51115920',
                },
                series_id: null,
                image_id: '103002452',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51115920',
                checkout_flow: 'moflo',
                name: 'Pre-Black Lives Matter March Solidarity Run',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/pre-black-lives-matter-march-solidarity-run-tickets-108762469474',
                hide_start_date: false,
                summary:
                    'Please join us in a solidarity run prior to the #blacklivesmatter March in Seattle, WA (Westlake) for black lives - it’s time.  All runners are welcomed.Please practice safe social distance at all times.  Bring your own water.Route: South Lake Union to Westlake - join the March which starts at 6pm. It’s approximately 2.2 miles TOTAL.  Please plan accordingly (how to get back and what you will be carrying to and from the march).  http://routes.rungoapp.com/route/vk5dyxxGJaTAG:  #pnwladie #run2bef',
                is_online_event: false,
                eid: '108762469474',
                published: '2020-06-08T19:09:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Restorative Healing in the Park',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102933218%2F312689997681%2F1%2Foriginal.20200608-041611?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C296%2C1242%2C621&s=5e36ec65435c68b95bf48e6863629140',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102933218%2F312689997681%2F1%2Foriginal.20200608-041611?auto=format%2Ccompress&q=75&sharp=10&s=93a6b3419cbef7f06520773482cdd7bf',
                        width: 1242,
                        height: 1032,
                    },
                    crop_mask: {
                        width: 1242,
                        height: 621,
                        top_left: {
                            y: 296,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102933218',
                },
                timezone: 'America/New_York',
                id: '108650229762',
                tickets_url:
                    'https://www.eventbrite.com/e/restorative-healing-in-the-park-tickets-108650229762',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30034063002',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/7002',
                        display_name: 'Mental health',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/107',
                        display_name: 'Health & Wellness',
                        localized: {
                            display_name: 'Health & Wellness',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/9',
                        display_name: 'Class, Training, or Workshop',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blackmentalhealth',
                        display_name: 'Blackmentalhealth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blackmindsmatterky',
                        display_name: 'Blackmindsmatterky',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Healingblackfamily',
                        display_name: 'Healingblackfamily',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacktherapists',
                        display_name: 'Blacktherapists',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108650229762',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '231 E Witherspoon St',
                    venue_profile_id: null,
                    address: {
                        city: 'Louisville',
                        country: 'US',
                        region: 'KY',
                        longitude: '-85.7504609',
                        localized_address_display:
                            '231 East Witherspoon Street, Louisville, KY 40202',
                        postal_code: '40202',
                        address_1: '231 East Witherspoon Street',
                        latitude: '38.2576782',
                        localized_multi_line_address_display: [
                            '231 East Witherspoon Street',
                            'Louisville, KY 40202',
                        ],
                        localized_area_display: 'Louisville, KY',
                    },
                    venue_profile_url: '',
                    id: '51096532',
                },
                series_id: null,
                image_id: '102933218',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51096532',
                checkout_flow: 'moflo',
                name: 'Restorative Healing in the Park',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/restorative-healing-in-the-park-tickets-108650229762',
                hide_start_date: false,
                summary:
                    'Black Licensed therapists will  lead you in a powerful therapeutic circle on racial injustices within the Black family to promote healing.',
                is_online_event: false,
                eid: 'ekkqwmr',
                published: '2020-06-08T04:35:31Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Speak On It',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103046364%2F173495752068%2F1%2Foriginal.20200609-052748?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=220%2C0%2C2160%2C1080&s=f8fbf9dc33e591bfbd4a25760aab5235',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103046364%2F173495752068%2F1%2Foriginal.20200609-052748?auto=format%2Ccompress&q=75&sharp=10&s=371291c726a61aa6712fb1d642a2688e',
                        width: 2600,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 220,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103046364',
                },
                timezone: 'America/Los_Angeles',
                id: '108816842104',
                tickets_url:
                    'https://www.eventbrite.com/e/speak-on-it-tickets-108816842104',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30461693608',
                hide_end_date: false,
                start_date: '2020-06-17',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-17',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community',
                        display_name: 'Community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Live music',
                        display_name: 'Live music',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Performance',
                        display_name: 'Performance',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Church',
                        display_name: 'Church',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Poetry',
                        display_name: 'Poetry',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Spoken word',
                        display_name: 'Spoken word',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Live performance',
                        display_name: 'Live performance',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/March',
                        display_name: 'March',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108816842104',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '16850 San Jacinto Ave',
                    venue_profile_id: null,
                    address: {
                        city: 'Fontana',
                        country: 'US',
                        region: 'CA',
                        longitude: '-117.4367111',
                        localized_address_display:
                            '16850 San Jacinto Avenue, Fontana, CA 92336',
                        postal_code: '92336',
                        address_1: '16850 San Jacinto Avenue',
                        latitude: '34.1179359',
                        localized_multi_line_address_display: [
                            '16850 San Jacinto Avenue',
                            'Fontana, CA 92336',
                        ],
                        localized_area_display: 'Fontana, CA',
                    },
                    venue_profile_url: '',
                    id: '51125470',
                },
                series_id: null,
                image_id: '103046364',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51125470',
                checkout_flow: 'moflo',
                name: 'Speak On It',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/speak-on-it-tickets-108816842104',
                hide_start_date: false,
                summary:
                    'First Faith World Ministries invites you to come and join our "Speak On It" rally!',
                is_online_event: false,
                eid: 'ekkxcdd',
                published: '2020-06-09T06:04:42Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'SPEAK UP & DRIBBLE: WE GOT NEXT - A PEACEFUL PROTEST FOR BLACK LIVES MATTER',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103346138%2F452644361132%2F1%2Foriginal.20200611-193526?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C47%2C1544%2C772&s=b27eaa35182d91070edbaa4cbbe8e6dd',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103346138%2F452644361132%2F1%2Foriginal.20200611-193526?auto=format%2Ccompress&q=75&sharp=10&s=6a7d3414ef01c36ed5d5e9569a798922',
                        width: 1544,
                        height: 841,
                    },
                    crop_mask: {
                        width: 1544,
                        height: 772,
                        top_left: {
                            y: 47,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103346138',
                },
                timezone: 'America/Los_Angeles',
                id: '109186509790',
                tickets_url:
                    'https://www.eventbrite.com/e/speak-up-dribble-supporting-the-black-community-outside-the-lines-tickets-109186509790',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30484069148',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '16:30',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                ],
                eventbrite_event_id: '109186509790',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Gene Friend Recreation Center',
                    venue_profile_id: null,
                    address: {
                        city: 'San Francisco',
                        country: 'US',
                        region: 'CA',
                        longitude: '-122.4062251',
                        localized_address_display:
                            '270 6th Street, San Francisco, CA 94103',
                        postal_code: '94103',
                        address_1: '270 6th Street',
                        latitude: '37.7787754',
                        localized_multi_line_address_display: [
                            '270 6th Street',
                            'San Francisco, CA 94103',
                        ],
                        localized_area_display: 'San Francisco, CA',
                    },
                    venue_profile_url: '',
                    id: '51201170',
                },
                series_id: null,
                image_id: '103346138',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51201170',
                checkout_flow: 'moflo',
                name:
                    'SPEAK UP & DRIBBLE: SUPPORTING THE BLACK COMMUNITY OUTSIDE THE LINES',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/speak-up-dribble-supporting-the-black-community-outside-the-lines-tickets-109186509790',
                hide_start_date: false,
                summary:
                    'SPEAK UP & DRIBBLE: SUPPORTING THE BLACK COMMUNITY OUTSIDE THE LINES is a peaceful protest declaring that Black Lives Matter',
                is_online_event: false,
                eid: '109186509790',
                published: '2020-06-11T17:35:21Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'StrongHer Together #blacklivesmatter',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103030180%2F277093890012%2F1%2Foriginal.20200609-003052?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C662%2C2048%2C1024&s=27b352589c4fc7d5863ad7d607851217',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103030180%2F277093890012%2F1%2Foriginal.20200609-003052?auto=format%2Ccompress&q=75&sharp=10&s=c7c187746a6573c5fce14880d6330327',
                        width: 2048,
                        height: 2048,
                    },
                    crop_mask: {
                        width: 2048,
                        height: 1024,
                        top_left: {
                            y: 662,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103030180',
                },
                timezone: 'America/Chicago',
                id: '108795959644',
                tickets_url:
                    'https://www.eventbrite.com/e/strongher-together-blacklivesmatter-tickets-108795959644',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30460275752',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                ],
                eventbrite_event_id: '108795959644',
                start_time: '18:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: "World's Fair Pavilion",
                    venue_profile_id: null,
                    address: {
                        city: 'St. Louis',
                        country: 'US',
                        region: 'MO',
                        longitude: '-90.2854947',
                        localized_address_display:
                            '1904 Concourse Drive, St. Louis, MO 63110',
                        postal_code: '63110',
                        address_1: '1904 Concourse Drive',
                        latitude: '38.63646190000001',
                        localized_multi_line_address_display: [
                            '1904 Concourse Drive',
                            'St. Louis, MO 63110',
                        ],
                        localized_area_display: 'St. Louis, MO',
                    },
                    venue_profile_url: '',
                    id: '51119886',
                },
                series_id: null,
                image_id: '103030180',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51119886',
                checkout_flow: 'moflo',
                name: 'StrongHer Together #blacklivesmatter',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/strongher-together-blacklivesmatter-tickets-108795959644',
                hide_start_date: false,
                summary:
                    'Charity workout to bring our community together to be part of change. Open to all: All genders. All ages. All races. All fitness levels.',
                is_online_event: false,
                eid: '108795959644',
                published: '2020-06-09T00:54:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Splash of Color: Painting to Liberate',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#a6a4a3',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103192844%2F37295342630%2F1%2Foriginal.20200610-135747?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C18%2C1198%2C599&s=73206e548bc1d520cc66d54485f18e70',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103192844%2F37295342630%2F1%2Foriginal.20200610-135747?auto=format%2Ccompress&q=75&sharp=10&s=2309193ee1d9782ec7f683cd0016741a',
                        width: 1200,
                        height: 800,
                    },
                    crop_mask: {
                        width: 1198,
                        height: 599,
                        top_left: {
                            y: 18,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103192844',
                },
                timezone: 'America/New_York',
                id: '108630593028',
                tickets_url:
                    'https://www.eventbrite.com/e/splash-of-color-painting-to-liberate-tickets-108630593028',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30450969058',
                hide_end_date: true,
                start_date: '2020-06-20',
                end_time: '14:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Art',
                        display_name: 'Art',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Creative',
                        display_name: 'Creative',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Paint',
                        display_name: 'Paint',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Diy',
                        display_name: 'Diy',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Paint and sip',
                        display_name: 'Paint and sip',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protests',
                        display_name: 'Protests',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Washington heights',
                        display_name: 'Washington heights',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108630593028',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '145 Entrance Riverbank State Park',
                    venue_profile_id: null,
                    address: {
                        city: 'New York',
                        country: 'US',
                        region: 'NY',
                        longitude: '-73.9506774',
                        localized_address_display:
                            '679 Riverside Drive Below the stairs, New York, NY 10031',
                        postal_code: '10031',
                        address_1: '679 Riverside Drive',
                        address_2: 'Below the stairs',
                        latitude: '40.8270209',
                        localized_multi_line_address_display: [
                            '679 Riverside Drive',
                            'Below the stairs',
                            'New York, NY 10031',
                        ],
                        localized_area_display: 'New York, NY',
                    },
                    venue_profile_url: '',
                    id: '51155688',
                },
                series_id: null,
                image_id: '103192844',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51155688',
                checkout_flow: 'moflo',
                name: 'Splash of Color: Painting to Liberate',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/splash-of-color-painting-to-liberate-tickets-108630593028',
                hide_start_date: false,
                summary:
                    'We want to provide a safe space for those who enjoy creating all while supporting Black Lives Matter.',
                is_online_event: false,
                eid: 'ekkqgkg',
                published: '2020-06-10T14:40:25Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Summerwood Unity Walk on Juneteenth',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#8e9543',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103246946%2F270115790868%2F1%2Foriginal.20200610-215534?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C2%2C1080%2C540&s=9afb15c8c4b41d379225bfd160f29062',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103246946%2F270115790868%2F1%2Foriginal.20200610-215534?auto=format%2Ccompress&q=75&sharp=10&s=c7f70066607028def04014d07e2c7ac7',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 2,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103246946',
                },
                timezone: 'America/Chicago',
                id: '109054635350',
                tickets_url:
                    'https://www.eventbrite.com/e/summerwood-unity-walk-on-juneteenth-tickets-109054635350',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18600376553',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '19:30',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Unity walk',
                        display_name: 'Unity walk',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Summerwood',
                        display_name: 'Summerwood',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109054635350',
                start_time: '18:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '14181 Summerwood Lakes Dr',
                    venue_profile_id: null,
                    address: {
                        city: 'Houston',
                        country: 'US',
                        region: 'TX',
                        longitude: '-95.1779311',
                        localized_address_display:
                            '14181 Summerwood Lakes Drive, Houston, TX 77044',
                        postal_code: '77044',
                        address_1: '14181 Summerwood Lakes Drive',
                        latitude: '29.925793',
                        localized_multi_line_address_display: [
                            '14181 Summerwood Lakes Drive',
                            'Houston, TX 77044',
                        ],
                        localized_area_display: 'Houston, TX',
                    },
                    venue_profile_url: '',
                    id: '51176158',
                },
                series_id: null,
                image_id: '103246946',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51176158',
                checkout_flow: 'moflo',
                name: 'Summerwood Unity Walk on Juneteenth',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/summerwood-unity-walk-on-juneteenth-tickets-109054635350',
                hide_start_date: false,
                summary:
                    'On Juneteenth, we march against racism and inequality!',
                is_online_event: false,
                eid: 'ekmdqhp',
                published: '2020-06-10T22:01:27Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'They See Us',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#c3c3b7',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102993908%2F450486285614%2F1%2Foriginal.20200608-175306?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C598%2C1080%2C540&s=2a49784c20245a472157e2703d165ac3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102993908%2F450486285614%2F1%2Foriginal.20200608-175306?auto=format%2Ccompress&q=75&sharp=10&s=14064b214aa28d6d98765634286d8397',
                        width: 1080,
                        height: 1920,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 598,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102993908',
                },
                timezone: 'America/New_York',
                id: '108752431450',
                tickets_url:
                    'https://www.eventbrite.com/e/they-see-us-tickets-108752431450',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30457405802',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Police reform',
                        display_name: 'Police reform',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/George floyd',
                        display_name: 'George floyd',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/The balance effect',
                        display_name: 'The balance effect',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108752431450',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Washington Square Park',
                    venue_profile_id: null,
                    address: {
                        city: 'New York',
                        country: 'US',
                        region: 'NY',
                        longitude: '-73.9996124',
                        localized_address_display:
                            '5 Ave, Waverly Pl., W. 4 St. and Macdougal St., New York, NY 10012',
                        postal_code: '10012',
                        address_1:
                            '5 Ave, Waverly Pl., W. 4 St. and Macdougal St.',
                        latitude: '40.7310533',
                        localized_multi_line_address_display: [
                            '5 Ave, Waverly Pl., W. 4 St. and Macdougal St.',
                            'New York, NY 10012',
                        ],
                        localized_area_display: 'New York, NY',
                    },
                    venue_profile_url: '',
                    id: '51114624',
                },
                series_id: null,
                image_id: '102993908',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51114624',
                checkout_flow: 'moflo',
                name: 'They See Us',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/they-see-us-tickets-108752431450',
                hide_start_date: false,
                summary:
                    'They See Us! Calling all our brothers to band together in style to peacefully protest police brutality',
                is_online_event: false,
                eid: 'ekktrfd',
                published: '2020-06-08T18:05:00Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: "The Brother's: Juneteenth March to The Capital",
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102973458%2F418662774549%2F1%2Foriginal.20200608-150520?w=450&auto=format%2Ccompress&q=75&sharp=10&rect=1%2C0%2C450%2C225&s=007ab8b3aeffd282fd3a690deb4a7dee',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102973458%2F418662774549%2F1%2Foriginal.20200608-150520?auto=format%2Ccompress&q=75&sharp=10&s=7d647316b5be5e832c0bb8c20d1af257',
                        width: 451,
                        height: 600,
                    },
                    crop_mask: {
                        width: 450,
                        height: 225,
                        top_left: {
                            y: 0,
                            x: 1,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102973458',
                },
                timezone: 'America/New_York',
                id: '108725091676',
                tickets_url:
                    'https://www.eventbrite.com/e/the-brothers-juneteenth-march-to-the-capital-tickets-108725091676',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30455830854',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '16:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#community',
                        display_name: '#community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenth',
                        display_name: '#juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blm',
                        display_name: '#blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#march',
                        display_name: '#march',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108725091676',
                start_time: '13:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'South Pearl Street & Green Street',
                    venue_profile_id: null,
                    address: {
                        city: 'Albany',
                        country: 'US',
                        region: 'NY',
                        longitude: '-73.75578399999999',
                        localized_address_display:
                            '224 S. Pearl Street , Albany, NY 12202',
                        postal_code: '12202',
                        address_1: '224 S. Pearl Street ',
                        latitude: '42.6419515',
                        localized_multi_line_address_display: [
                            '224 S. Pearl Street',
                            'Albany, NY 12202',
                        ],
                        localized_area_display: 'Albany, NY',
                    },
                    venue_profile_url: '',
                    id: '51109982',
                },
                series_id: null,
                image_id: '102973458',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51109982',
                checkout_flow: 'moflo',
                name: "The Brother's: Juneteenth March to The Capital",
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/the-brothers-juneteenth-march-to-the-capital-tickets-108725091676',
                hide_start_date: false,
                summary:
                    'March for Black Excellence and the power of Community. Black Lives Matter. Come together in solidarity in Celebration of Juneteenth.',
                is_online_event: false,
                eid: 'ekktcgy',
                published: '2020-06-08T15:43:12Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Tucker "Walk for Justice"',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#6c2523',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102997696%2F262678986105%2F1%2Foriginal.20200608-182834?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=11%2C0%2C730%2C365&s=706e12e7dcb01298a0ec31660e5c2356',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102997696%2F262678986105%2F1%2Foriginal.20200608-182834?auto=format%2Ccompress&q=75&sharp=10&s=079e2c70435bd6b9acdc6dfd86217b5b',
                        width: 756,
                        height: 365,
                    },
                    crop_mask: {
                        width: 730,
                        height: 365,
                        top_left: {
                            y: 0,
                            x: 11,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102997696',
                },
                timezone: 'America/New_York',
                id: '108744403438',
                tickets_url:
                    'https://www.eventbrite.com/e/tucker-walk-for-justice-tickets-108744403438',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '24190771291',
                hide_end_date: false,
                start_date: '2020-06-27',
                end_time: '12:00',
                _type: 'destination_event',
                end_date: '2020-06-27',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/17',
                        display_name: 'Attraction',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#freedom',
                        display_name: '#freedom',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#equality',
                        display_name: '#equality',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#ovrcmr',
                        display_name: '#ovrcmr',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#nojusticenopeace',
                        display_name: '#nojusticenopeace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#nohate',
                        display_name: '#nohate',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#tuckerwalkforjustice',
                        display_name: '#tuckerwalkforjustice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#tuckerwalk',
                        display_name: '#tuckerwalk',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#dekalbcounty',
                        display_name: '#dekalbcounty',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#omegasupport',
                        display_name: '#omegasupport',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108744403438',
                start_time: '09:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Tucker',
                    venue_profile_id: null,
                    address: {
                        city: 'Tucker',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.21626979999999',
                        localized_address_display:
                            '5036 Lavista Road, Tucker, GA 30084',
                        postal_code: '30084',
                        address_1: '5036 Lavista Road',
                        latitude: '33.8563929',
                        localized_multi_line_address_display: [
                            '5036 Lavista Road',
                            'Tucker, GA 30084',
                        ],
                        localized_area_display: 'Tucker, GA',
                    },
                    venue_profile_url: '',
                    id: '51113062',
                },
                series_id: null,
                image_id: '102997696',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51113062',
                checkout_flow: 'moflo',
                name: 'Tucker  "Walk for Justice"',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/tucker-walk-for-justice-tickets-108744403438',
                hide_start_date: false,
                summary: 'TUCKER "WALK FOR JUSTICE"',
                is_online_event: false,
                eid: 'ekktmdw',
                published: '2020-06-08T17:00:15Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'ARTrageous Birthday & Juneteenth Event',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#868e4f',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103265850%2F214932276463%2F1%2Foriginal.20200605-032040?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C800%2C400&s=3068bd1499b4b804031eb7c32f613f96',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103265850%2F214932276463%2F1%2Foriginal.20200605-032040?auto=format%2Ccompress&q=75&sharp=10&s=b81be4d134189a47fe022f0c50b189c5',
                        width: 800,
                        height: 400,
                    },
                    crop_mask: {
                        width: 800,
                        height: 400,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103265850',
                },
                timezone: 'America/New_York',
                id: '108406398456',
                tickets_url:
                    'https://www.eventbrite.com/e/artrageous-birthday-juneteenth-event-tickets-108406398456',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '14781978568',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/5012',
                        display_name: 'Painting',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/105',
                        display_name: 'Performing & Visual Arts',
                        localized: {
                            display_name: 'Performing & Visual Arts',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Family',
                        display_name: 'Family',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Celebration',
                        display_name: 'Celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Weekend',
                        display_name: 'Weekend',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Painting',
                        display_name: 'Painting',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Philly',
                        display_name: 'Philly',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108406398456',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'ARTrageous Brush & Flow',
                    venue_profile_id: null,
                    address: {
                        city: 'Philadelphia',
                        country: 'US',
                        region: 'PA',
                        longitude: '-75.18145',
                        localized_address_display:
                            '6345 Germantown Avenue, Philadelphia, PA 19144',
                        postal_code: '19144',
                        address_1: '6345 Germantown Avenue',
                        latitude: '40.04483',
                        localized_multi_line_address_display: [
                            '6345 Germantown Avenue',
                            'Philadelphia, PA 19144',
                        ],
                        localized_area_display: 'Philadelphia, PA',
                    },
                    venue_profile_url: '',
                    id: '51032236',
                },
                series_id: null,
                image_id: '103265850',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51032236',
                checkout_flow: 'moflo',
                name: 'ARTrageous Birthday & Juneteenth Event',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/artrageous-birthday-juneteenth-event-tickets-108406398456',
                hide_start_date: false,
                summary:
                    "Celebrate Our Birthday with us! We will be celebrating our storefront's birthday while celebrating Juneteenth.",
                is_online_event: false,
                eid: 'ekkgmzp',
                published: '2020-06-05T03:23:25Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Yoga for Black Lives Matter',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#272727',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102898084%2F309229074626%2F1%2Foriginal.20200607-132730?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C630%2C315&s=7d6b600d334139148adc69b32b9c0e03',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102898084%2F309229074626%2F1%2Foriginal.20200607-132730?auto=format%2Ccompress&q=75&sharp=10&s=03ffd8b711c6e12c673af6d79513a5bb',
                        width: 828,
                        height: 315,
                    },
                    crop_mask: {
                        width: 630,
                        height: 315,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102898084',
                },
                timezone: 'America/New_York',
                id: '108611152882',
                tickets_url:
                    'https://www.eventbrite.com/e/yoga-for-black-lives-matter-tickets-108611152882',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '21673698259',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '20:30',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/8019',
                        display_name: 'Yoga',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/108',
                        display_name: 'Sports & Fitness',
                        localized: {
                            display_name: 'Sports & Fitness',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/9',
                        display_name: 'Class, Training, or Workshop',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#fitness',
                        display_name: '#fitness',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Donate',
                        display_name: 'Donate',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#yoga',
                        display_name: '#yoga',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#health',
                        display_name: '#health',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#mental health',
                        display_name: '#mental health',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#blacklivesmatter',
                        display_name: '#blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#mental wellness',
                        display_name: '#mental wellness',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#physical health',
                        display_name: '#physical health',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Social distancing',
                        display_name: 'Social distancing',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#donationyoga',
                        display_name: '#donationyoga',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108611152882',
                start_time: '19:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name:
                        'National Museum of African American History and Culture',
                    venue_profile_id: null,
                    address: {
                        city: 'Washington',
                        country: 'US',
                        region: 'DC',
                        longitude: '-77.032614',
                        localized_address_display:
                            '1400 Constitution Avenue Northwest, Washington, DC 20560',
                        postal_code: '20560',
                        address_1: '1400 Constitution Avenue Northwest',
                        latitude: '38.8910644',
                        localized_multi_line_address_display: [
                            '1400 Constitution Avenue Northwest',
                            'Washington, DC 20560',
                        ],
                        localized_area_display: 'Washington, DC',
                    },
                    venue_profile_url: '',
                    id: '51094374',
                },
                series_id: '108610452788',
                image_id: '102898084',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51094374',
                checkout_flow: 'moflo',
                name: 'Yoga for Black Lives Matter',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/yoga-for-black-lives-matter-tickets-108611152882',
                hide_start_date: false,
                summary:
                    'Outdoor donation based yoga led by @YogiRachelB - founder of Evolving Lives Body and Mind. Proceeds will support  #blacklivesmatter',
                is_online_event: false,
                eid: 'ekkpwmg',
                published: '2020-06-08T00:31:51Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'We Demand Action',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102477588%2F316690681799%2F1%2Foriginal.20200602-172659?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C270%2C1080%2C540&s=df26ba9187bf6b935623f70cc840f9ed',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102477588%2F316690681799%2F1%2Foriginal.20200602-172659?auto=format%2Ccompress&q=75&sharp=10&s=dcc79e8c5f738c6448c23c8f952c3584',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 270,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102477588',
                },
                timezone: 'America/Chicago',
                id: '107694015700',
                tickets_url:
                    'https://www.eventbrite.com/e/we-demand-action-tickets-107694015700',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30415423972',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '14:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/199',
                        display_name: 'Other',
                        localized: {
                            display_name: 'Other',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/2',
                        display_name: 'Seminar or Talk',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Voice',
                        display_name: 'Voice',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Love',
                        display_name: 'Love',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Change',
                        display_name: 'Change',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peace',
                        display_name: 'Peace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Action',
                        display_name: 'Action',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Alabama',
                        display_name: 'Alabama',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Birmingham',
                        display_name: 'Birmingham',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Advocate',
                        display_name: 'Advocate',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Greek',
                        display_name: 'Greek',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peaceful',
                        display_name: 'Peaceful',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/March',
                        display_name: 'March',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '107694015700',
                start_time: '09:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Railroad Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Birmingham',
                        country: 'US',
                        region: 'AL',
                        longitude: '-86.8084382',
                        localized_address_display:
                            '1600 First Ave. S, Birmingham, AL 35233',
                        postal_code: '35233',
                        address_1: '1600 First Ave. S',
                        latitude: '33.5099169',
                        localized_multi_line_address_display: [
                            '1600 First Ave. S',
                            'Birmingham, AL 35233',
                        ],
                        localized_area_display: 'Birmingham, AL',
                    },
                    venue_profile_url: '',
                    id: '50972246',
                },
                series_id: null,
                image_id: '102477588',
                is_cancelled: null,
                primary_venue_id: '50972246',
                checkout_flow: 'moflo',
                name: 'We Demand Action',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/we-demand-action-tickets-107694015700',
                hide_start_date: false,
                summary: 'Join Us As We Come Together As One Voice',
                is_online_event: false,
                eid: 'ekhxrrd',
                published: '2020-06-02T17:28:43Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Unity Caravan',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103141744%2F56974548493%2F1%2Foriginal.20200609-234605?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C156%2C2966%2C1483&s=2442ea261311de5a23469a49afde51b0',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103141744%2F56974548493%2F1%2Foriginal.20200609-234605?auto=format%2Ccompress&q=75&sharp=10&s=e1be5a2f7f1653919969c627809c0876',
                        width: 2966,
                        height: 1795,
                    },
                    crop_mask: {
                        width: 2966,
                        height: 1483,
                        top_left: {
                            y: 156,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103141744',
                },
                timezone: 'America/New_York',
                id: '108931595334',
                tickets_url:
                    'https://www.eventbrite.com/e/unity-caravan-tickets-108931595334',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30469248122',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '13:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Peace',
                        display_name: 'Peace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Racial equality',
                        display_name: 'Racial equality',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108931595334',
                start_time: '10:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Weston Community Center at Regional Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Weston',
                        country: 'US',
                        region: 'FL',
                        longitude: '-80.418954',
                        localized_address_display:
                            '20200 Saddle Club Road, Weston, FL 33327',
                        postal_code: '33327',
                        address_1: '20200 Saddle Club Road',
                        latitude: '26.10624199999999',
                        localized_multi_line_address_display: [
                            '20200 Saddle Club Road',
                            'Weston, FL 33327',
                        ],
                        localized_area_display: 'Weston, FL',
                    },
                    venue_profile_url: '',
                    id: '51150422',
                },
                series_id: null,
                image_id: '103141744',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51150422',
                checkout_flow: 'moflo',
                name: 'Unity Caravan',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/unity-caravan-tickets-108931595334',
                hide_start_date: false,
                summary:
                    'Please join us for a family-friendly, peaceful caravan to show your support for racial equality, unity, love, peace, justice.',
                is_online_event: false,
                eid: 'ekkztzd',
                published: '2020-06-09T23:50:44Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Black Empowerment Expo',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#f4dfcd',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102921540%2F165714667096%2F1%2Foriginal.20200607-230532?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C51%2C1128%2C564&s=adc1cf6eb57395a9fd0e374c8efc61b4',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102921540%2F165714667096%2F1%2Foriginal.20200607-230532?auto=format%2Ccompress&q=75&sharp=10&s=515bb23c7d0fbaa75fb5e878f609702d',
                        width: 1129,
                        height: 1495,
                    },
                    crop_mask: {
                        width: 1128,
                        height: 564,
                        top_left: {
                            y: 51,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102921540',
                },
                timezone: 'America/Detroit',
                id: '108634518770',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-black-empowerment-expo-tickets-108634518770',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17705106224',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '19:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Networking',
                        display_name: 'Networking',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Entertainment',
                        display_name: 'Entertainment',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Live music',
                        display_name: 'Live music',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Spoken word',
                        display_name: 'Spoken word',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Information',
                        display_name: 'Information',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black empowerment',
                        display_name: 'Black empowerment',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108634518770',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '21300 Hilltop St',
                    venue_profile_id: null,
                    address: {
                        city: 'Southfield',
                        country: 'US',
                        region: 'MI',
                        longitude: '-83.28580219999999',
                        localized_address_display:
                            '21300 Hilltop Street, Southfield, MI 48033',
                        postal_code: '48033',
                        address_1: '21300 Hilltop Street',
                        latitude: '42.4478287',
                        localized_multi_line_address_display: [
                            '21300 Hilltop Street',
                            'Southfield, MI 48033',
                        ],
                        localized_area_display: 'Southfield, MI',
                    },
                    venue_profile_url: '',
                    id: '51093514',
                },
                series_id: null,
                image_id: '102921540',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51093514',
                checkout_flow: 'moflo',
                name: 'Juneteenth Black Empowerment Expo',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-black-empowerment-expo-tickets-108634518770',
                hide_start_date: false,
                summary:
                    'The Juneteenth Black Empowerment Expo will be a day of entertainment, information and networking you do not want to miss!',
                is_online_event: false,
                eid: 'ekkqkmg',
                published: '2020-06-07T21:57:17Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Hip Hop N Paint',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#1b1b1b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102711358%2F368619333545%2F1%2Foriginal.20200604-185254?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=4d0318b6390d70491edd76710fed219a',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102711358%2F368619333545%2F1%2Foriginal.20200604-185254?auto=format%2Ccompress&q=75&sharp=10&s=f6ea7d44e85ee74d19c1952314bfc1b9',
                        width: 2160,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102711358',
                },
                timezone: 'America/Chicago',
                id: '108046588254',
                tickets_url:
                    'https://www.eventbrite.com/e/hip-hop-n-paint-tickets-108046588254',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28262460993',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '00:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/3008',
                        display_name: 'Hip Hop / Rap',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/103',
                        display_name: 'Music',
                        localized: {
                            display_name: 'Music',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Celebration',
                        display_name: 'Celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hip hop',
                        display_name: 'Hip hop',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Painting',
                        display_name: 'Painting',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Alcohol',
                        display_name: 'Alcohol',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108046588254',
                start_time: '20:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Clarion Hotel Convention Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Minot',
                        country: 'US',
                        region: 'ND',
                        longitude: '-101.26185229999999',
                        localized_address_display:
                            '2200 East Burdick Expressway, Minot, ND 58701',
                        postal_code: '58701',
                        address_1: '2200 East Burdick Expressway',
                        latitude: '48.2288397',
                        localized_multi_line_address_display: [
                            '2200 East Burdick Expressway',
                            'Minot, ND 58701',
                        ],
                        localized_area_display: 'Minot, ND',
                    },
                    venue_profile_url: '',
                    id: '51004168',
                },
                series_id: null,
                image_id: '102711358',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51004168',
                checkout_flow: 'moflo',
                name: 'Hip Hop N Paint',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/hip-hop-n-paint-tickets-108046588254',
                hide_start_date: false,
                summary:
                    'Come & dust off the quarantine cobwebs and celebrate a piece of black history. Juneteenth Hip Hop and Paint... Music, Paint N Drinks',
                is_online_event: false,
                eid: 'ekkckbg',
                published: '2020-06-04T18:55:29Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Celebration: Wear Your Crown',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#271531',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102769522%2F3817958933%2F1%2Foriginal.20200605-111224?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=f7dae8b93e2ccae32b00a355ddd4ec18',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102769522%2F3817958933%2F1%2Foriginal.20200605-111224?auto=format%2Ccompress&q=75&sharp=10&s=0e811bb693c767c39ee78562fe3e0274',
                        width: 2160,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102769522',
                },
                timezone: 'America/Chicago',
                id: '108101494480',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-wear-your-crown-tickets-108101494480',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30431443328',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#culture',
                        display_name: '#culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#black',
                        display_name: '#black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenth',
                        display_name: '#juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#excellence',
                        display_name: '#excellence',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108101494480',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'SANDAGA 813',
                    venue_profile_id: null,
                    address: {
                        city: 'Dallas',
                        country: 'US',
                        region: 'TX',
                        longitude: '-96.7675544',
                        localized_address_display:
                            '813 Exposition Avenue, Dallas, TX 75226',
                        postal_code: '75226',
                        address_1: '813 Exposition Avenue',
                        latitude: '32.7822618',
                        localized_multi_line_address_display: [
                            '813 Exposition Avenue',
                            'Dallas, TX 75226',
                        ],
                        localized_area_display: 'Dallas, TX',
                    },
                    venue_profile_url: '',
                    id: '51017122',
                },
                series_id: null,
                image_id: '102769522',
                is_cancelled: null,
                primary_venue_id: '51017122',
                checkout_flow: 'moflo',
                name: 'Juneteenth Celebration: Wear Your Crown',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-wear-your-crown-tickets-108101494480',
                hide_start_date: false,
                summary:
                    'Join Fit2Win Lifestyles and Drica the Diva as we kickoff our Juneteenth Community Celebration!',
                is_online_event: false,
                eid: 'ekkdkyp',
                published: '2020-06-04T12:28:57Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Jam',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#f7f7f7',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102933274%2F278652989846%2F1%2Foriginal.20200608-041706?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C128%2C1080%2C540&s=99acda06df3eb35e0bb89fb982fa9fc6',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102933274%2F278652989846%2F1%2Foriginal.20200608-041706?auto=format%2Ccompress&q=75&sharp=10&s=6659ee60d76bb3b12b56e018f6e1f575',
                        width: 1080,
                        height: 1068,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 128,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102933274',
                },
                timezone: 'America/New_York',
                id: '108652378188',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-jam-tickets-108652378188',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29103823591',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atlanta',
                        display_name: 'Atlanta',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Small business',
                        display_name: 'Small business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Festival',
                        display_name: 'Festival',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Basketball',
                        display_name: 'Basketball',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Buy black',
                        display_name: 'Buy black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black owned',
                        display_name: 'Black owned',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108652378188',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Big Miller Grove Missionary Baptist Church',
                    venue_profile_id: null,
                    address: {
                        city: 'Stonecrest',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.1745686',
                        localized_address_display:
                            '3800 Big Miller Grove Way, Stonecrest, GA 30038',
                        postal_code: '30038',
                        address_1: '3800 Big Miller Grove Way',
                        latitude: '33.6809432',
                        localized_multi_line_address_display: [
                            '3800 Big Miller Grove Way',
                            'Stonecrest, GA 30038',
                        ],
                        localized_area_display: 'Stonecrest, GA',
                    },
                    venue_profile_url: '',
                    id: '51097082',
                },
                series_id: null,
                image_id: '102933274',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51097082',
                checkout_flow: 'moflo',
                name: 'Juneteenth Jam',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-jam-tickets-108652378188',
                hide_start_date: false,
                summary:
                    "The Atlanta Legends and Georgia Spartans  bring you the 2nd Annual Juneteenth Jam. Hosted by the United Men's Basketball League",
                is_online_event: false,
                eid: 'ekkqxdb',
                published: '2020-06-08T04:38:50Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: "Opal's Walk Caravan",
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#bc9e9a',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103124494%2F175546064488%2F1%2Foriginal.20200609-202509?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C1334%2C667&s=667746da8b332c43d1d25df84a536b0d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103124494%2F175546064488%2F1%2Foriginal.20200609-202509?auto=format%2Ccompress&q=75&sharp=10&s=3df3236b8443a1d28d8d4700fe8563c6',
                        width: 1334,
                        height: 1600,
                    },
                    crop_mask: {
                        width: 1334,
                        height: 667,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103124494',
                },
                timezone: 'America/Chicago',
                id: '108595909288',
                tickets_url:
                    'https://www.eventbrite.com/e/opals-walk-caravan-tickets-108595909288',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '10766691943',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '12:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/11004',
                        display_name: 'Human Rights',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/111',
                        display_name: 'Charity & Causes',
                        localized: {
                            display_name: 'Charity & Causes',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Parade',
                        display_name: 'Parade',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Holiday',
                        display_name: 'Holiday',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black history',
                        display_name: 'Black history',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fort worth',
                        display_name: 'Fort worth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Caravan',
                        display_name: 'Caravan',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Opalswalk',
                        display_name: 'Opalswalk',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108595909288',
                start_time: '09:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Fort Worth Convention Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Fort Worth',
                        country: 'US',
                        region: 'TX',
                        longitude: '-97.3280004',
                        localized_address_display:
                            '1201 Houston Street, Fort Worth, TX 76102',
                        postal_code: '76102',
                        address_1: '1201 Houston Street',
                        latitude: '32.7498885',
                        localized_multi_line_address_display: [
                            '1201 Houston Street',
                            'Fort Worth, TX 76102',
                        ],
                        localized_area_display: 'Fort Worth, TX',
                    },
                    venue_profile_url: '',
                    id: '51079750',
                },
                series_id: null,
                image_id: '103124494',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51079750',
                checkout_flow: 'moflo',
                name: "Opal's Walk Caravan",
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/opals-walk-caravan-tickets-108595909288',
                hide_start_date: false,
                summary:
                    'In lieu of a parade, Ms. Opal Lee will lead the 2.5 mile caravan through downtown Fort Worth to commemorate freedom from slavery.',
                is_online_event: false,
                eid: 'ekkppwy',
                published: '2020-06-07T06:30:47Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Paint, Sip, and Karaoke',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#dfa37d',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102826276%2F366784778931%2F1%2Foriginal.20200605-224701?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C793%2C1242%2C621&s=680ddb2870ff0ac9d1008c0999ca2ce7',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102826276%2F366784778931%2F1%2Foriginal.20200605-224701?auto=format%2Ccompress&q=75&sharp=10&s=7296ded76098ec5afe1b671b9e296670',
                        width: 1242,
                        height: 2208,
                    },
                    crop_mask: {
                        width: 1242,
                        height: 621,
                        top_left: {
                            y: 793,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102826276',
                },
                timezone: 'America/Chicago',
                id: '108502702504',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-paint-sip-and-karaoke-tickets-108502702504',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29748801049',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '23:30',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/19007',
                        display_name: 'Adult',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/119',
                        display_name: 'Hobbies & Special Interest',
                        localized: {
                            display_name: 'Hobbies & Special Interest',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Party',
                        display_name: 'Party',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Art',
                        display_name: 'Art',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Karaoke',
                        display_name: 'Karaoke',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Paint and sip',
                        display_name: 'Paint and sip',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Paint party',
                        display_name: 'Paint party',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Trap and paint',
                        display_name: 'Trap and paint',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/June 19',
                        display_name: 'June 19',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Flava haus',
                        display_name: 'Flava haus',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108502702504',
                start_time: '20:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Flava Haus',
                    venue_profile_id: null,
                    address: {
                        city: 'Arlington',
                        country: 'US',
                        region: 'TX',
                        longitude: '-97.1359797',
                        localized_address_display:
                            '1730 W. Bardin Suite 400, Arlington, TX 76017',
                        postal_code: '76017',
                        address_1: '1730 W. Bardin',
                        address_2: 'Suite 400',
                        latitude: '32.6699617',
                        localized_multi_line_address_display: [
                            '1730 W. Bardin',
                            'Suite 400',
                            'Arlington, TX 76017',
                        ],
                        localized_area_display: 'Arlington, TX',
                    },
                    venue_profile_url: '',
                    id: '51051962',
                },
                series_id: '108502267202',
                image_id: '102826276',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51051962',
                checkout_flow: 'moflo',
                name: 'Juneteenth Paint, Sip, and Karaoke',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-paint-sip-and-karaoke-tickets-108502702504',
                hide_start_date: false,
                summary: 'Paint, Sip, and Karaoke',
                is_online_event: false,
                eid: 'ekkkrck',
                published: '2020-06-05T22:52:33Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '#BMoreFree Juneteenth Cookout',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#772e1d',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103360606%2F452643464902%2F1%2Foriginal.20200611-221641?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C750%2C375&s=a4f523111a4837bbdfe89a3bb73833df',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103360606%2F452643464902%2F1%2Foriginal.20200611-221641?auto=format%2Ccompress&q=75&sharp=10&s=c4a7f3577d16607605c693070619f5db',
                        width: 750,
                        height: 755,
                    },
                    crop_mask: {
                        width: 750,
                        height: 375,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103360606',
                },
                timezone: 'America/New_York',
                id: '109229961756',
                tickets_url:
                    'https://www.eventbrite.com/e/bmorefree-juneteenth-cookout-tickets-109229961756',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30485152680',
                hide_end_date: true,
                start_date: '2020-06-19',
                end_time: '21:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/10003',
                        display_name: 'Food',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/110',
                        display_name: 'Food & Drink',
                        localized: {
                            display_name: 'Food & Drink',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black',
                        display_name: 'Black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cookout',
                        display_name: 'Cookout',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Family friendly',
                        display_name: 'Family friendly',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Indigenous',
                        display_name: 'Indigenous',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Baltimore',
                        display_name: 'Baltimore',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109229961756',
                start_time: '16:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '4100 Towanda Ave',
                    venue_profile_id: null,
                    address: {
                        city: 'Baltimore',
                        country: 'US',
                        region: 'MD',
                        longitude: '-76.66574589999999',
                        localized_address_display:
                            '4100 Towanda Avenue, Baltimore, MD 21215',
                        postal_code: '21215',
                        address_1: '4100 Towanda Avenue',
                        latitude: '39.3337581',
                        localized_multi_line_address_display: [
                            '4100 Towanda Avenue',
                            'Baltimore, MD 21215',
                        ],
                        localized_area_display: 'Baltimore, MD',
                    },
                    venue_profile_url: '',
                    id: '51205544',
                },
                series_id: null,
                image_id: '103360606',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51205544',
                checkout_flow: 'moflo',
                name: '#BMoreFree Juneteenth Cookout',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/bmorefree-juneteenth-cookout-tickets-109229961756',
                hide_start_date: false,
                summary:
                    'A celebration of Black Culture, Black Pride, Black Love & Black Excellence with free food, music, entertainment, giveaways,  dancing & more!',
                is_online_event: false,
                eid: 'ekmhrkr',
                published: '2020-06-11T22:41:44Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Dallas Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#f90008',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103147098%2F171367938914%2F1%2Foriginal.20200610-010946?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C12%2C828%2C414&s=71b61557d8f9797a34124ae381344678',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103147098%2F171367938914%2F1%2Foriginal.20200610-010946?auto=format%2Ccompress&q=75&sharp=10&s=5486daa2786505cdba0cc182c4d819de',
                        width: 828,
                        height: 662,
                    },
                    crop_mask: {
                        width: 828,
                        height: 414,
                        top_left: {
                            y: 12,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103147098',
                },
                timezone: 'America/Chicago',
                id: '108938461872',
                tickets_url:
                    'https://www.eventbrite.com/e/dallas-juneteenth-celebration-tickets-108938461872',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30469681132',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '22:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#june',
                        display_name: '#june',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#juneteenthcelebration',
                        display_name: '#juneteenthcelebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#dallas_community',
                        display_name: '#dallas_community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/#griggspark',
                        display_name: '#griggspark',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108938461872',
                start_time: '17:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '2100 Clark St',
                    venue_profile_id: null,
                    address: {
                        city: 'Dallas',
                        country: 'US',
                        region: 'TX',
                        longitude: '-96.79463',
                        localized_address_display:
                            '2100 Clark Street, Dallas, TX 75204',
                        postal_code: '75204',
                        address_1: '2100 Clark Street',
                        latitude: '32.7957729',
                        localized_multi_line_address_display: [
                            '2100 Clark Street',
                            'Dallas, TX 75204',
                        ],
                        localized_area_display: 'Dallas, TX',
                    },
                    venue_profile_url: '',
                    id: '51152044',
                },
                series_id: null,
                image_id: '103147098',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51152044',
                checkout_flow: 'moflo',
                name: 'Dallas Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/dallas-juneteenth-celebration-tickets-108938461872',
                hide_start_date: false,
                summary: 'To our brothers and sisters of the Dallas Community.',
                is_online_event: false,
                eid: 'ekkzxzy',
                published: '2020-06-10T01:11:55Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Black Friday Orlando - Juneteenth 2020',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: null,
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103019126%2F139427885725%2F1%2Foriginal.20200608-215431?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C60%2C1920%2C960&s=425eb62bd988dcd37b0e461b7bbb5861',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103019126%2F139427885725%2F1%2Foriginal.20200608-215431?auto=format%2Ccompress&q=75&sharp=10&s=4b5f8dceb421ff82361d9a8d0814b41e',
                        width: 1920,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1920,
                        height: 960,
                        top_left: {
                            y: 60,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103019126',
                },
                timezone: 'America/New_York',
                id: '108781245634',
                tickets_url:
                    'https://www.eventbrite.com/e/black-friday-orlando-juneteenth-2020-tickets-108781245634',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '8057734054',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '21:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [],
                eventbrite_event_id: '108781245634',
                start_time: '09:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Orlando',
                    venue_profile_id: null,
                    address: {
                        city: 'Orlando',
                        country: 'US',
                        region: 'FL',
                        longitude: '-81.3792365',
                        localized_address_display: 'orange ave, Orlando, FL',
                        address_1: 'orange ave',
                        latitude: '28.5383355',
                        localized_multi_line_address_display: [
                            'orange ave',
                            'Orlando, FL',
                        ],
                        localized_area_display: 'Orlando, FL',
                    },
                    venue_profile_url: '',
                    id: '51118068',
                },
                series_id: null,
                image_id: '103019126',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51118068',
                checkout_flow: 'moflo',
                name: 'Black Friday Orlando - Juneteenth 2020',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/black-friday-orlando-juneteenth-2020-tickets-108781245634',
                hide_start_date: false,
                summary:
                    "Let's celebrate Juneteenth by putting money in the hands of Black Owned Businesses!",
                is_online_event: false,
                eid: '108781245634',
                published: '2020-06-09T15:01:41Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                '9th Annual Hungry Black Man Juneteenth Food & Music Festival',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#b28b5b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103298554%2F192731636251%2F1%2Foriginal.20200611-121715?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C539%2C1500%2C750&s=c740f88b7e7d1d222e22f0258ee4abe1',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103298554%2F192731636251%2F1%2Foriginal.20200611-121715?auto=format%2Ccompress&q=75&sharp=10&s=3b7dc3a3e5894cf8c384746f594b8483',
                        width: 1500,
                        height: 2100,
                    },
                    crop_mask: {
                        width: 1500,
                        height: 750,
                        top_left: {
                            y: 539,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103298554',
                },
                timezone: 'America/New_York',
                id: '109144486096',
                tickets_url:
                    'https://www.eventbrite.com/e/9th-annual-hungry-black-man-juneteenth-food-music-festival-tickets-109144486096',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '14363929567',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '23:30',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/110',
                        display_name: 'Food & Drink',
                        localized: {
                            display_name: 'Food & Drink',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109144486096',
                start_time: '20:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Dukunoo Jamaican Kitchen',
                    venue_profile_id: null,
                    address: {
                        city: 'Miami',
                        country: 'US',
                        region: 'FL',
                        longitude: '-80.2006526',
                        localized_address_display:
                            '316 Northwest 24th Street, Miami, FL 33127',
                        postal_code: '33127',
                        address_1: '316 Northwest 24th Street',
                        latitude: '25.7999768',
                        localized_multi_line_address_display: [
                            '316 Northwest 24th Street',
                            'Miami, FL 33127',
                        ],
                        localized_area_display: 'Miami, FL',
                    },
                    venue_profile_url: '',
                    id: '51192360',
                },
                series_id: null,
                image_id: '103298554',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51192360',
                checkout_flow: 'moflo',
                name:
                    '9th Annual Hungry Black Man Juneteenth Food & Music Festival',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/9th-annual-hungry-black-man-juneteenth-food-music-festival-tickets-109144486096',
                hide_start_date: false,
                summary:
                    "Juneteenth is a celebration of the ending of slavery in the United States. It's time to celebrate our future and respect our ancestors.",
                is_online_event: false,
                eid: 'ekmfxrw',
                published: '2020-06-11T12:16:15Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#2f392c',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95593075%2F393432272737%2F1%2Foriginal.20200305-210026?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C303%2C1200%2C600&s=1aa2d2b1d9c9a8e0b2fb7eaf4379a0ab',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95593075%2F393432272737%2F1%2Foriginal.20200305-210026?auto=format%2Ccompress&q=75&sharp=10&s=c285276ab3f48cf229b4ec4f305dcb9b',
                        width: 1200,
                        height: 1200,
                    },
                    crop_mask: {
                        width: 1200,
                        height: 600,
                        top_left: {
                            y: 303,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '95593075',
                },
                timezone: 'America/Los_Angeles',
                id: '98481393499',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-98481393499',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29089584611',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '02:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/3005',
                        display_name: 'Cultural',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/103',
                        display_name: 'Music',
                        localized: {
                            display_name: 'Music',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/African',
                        display_name: 'African',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hip hop',
                        display_name: 'Hip hop',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Culture',
                        display_name: 'Culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Reggae',
                        display_name: 'Reggae',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Afrobeats',
                        display_name: 'Afrobeats',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Jamaica',
                        display_name: 'Jamaica',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Afrobeat',
                        display_name: 'Afrobeat',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Hollywood',
                        display_name: 'Hollywood',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Jamaican',
                        display_name: 'Jamaican',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '98481393499',
                start_time: '22:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Station1640',
                    venue_profile_id: null,
                    address: {
                        city: 'Los Angeles',
                        country: 'US',
                        region: 'CA',
                        longitude: '-118.3292131',
                        localized_address_display:
                            '1640 North Cahuenga Boulevard, Los Angeles, CA 90028',
                        postal_code: '90028',
                        address_1: '1640 North Cahuenga Boulevard',
                        latitude: '34.1010358',
                        localized_multi_line_address_display: [
                            '1640 North Cahuenga Boulevard',
                            'Los Angeles, CA 90028',
                        ],
                        localized_area_display: 'Los Angeles, CA',
                    },
                    venue_profile_url: '',
                    id: '49208061',
                },
                series_id: null,
                image_id: '95593075',
                is_cancelled: null,
                primary_venue_id: '49208061',
                checkout_flow: 'moflo',
                name: 'Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-98481393499',
                hide_start_date: false,
                summary:
                    'We are Celebrating Juneteenth the Speakerbox way; with a Blend of Cultures:  Afrobeats x Reggae x Hip Hop & More.',
                is_online_event: false,
                eid: 'ehwbqhk',
                published: '2020-03-05T21:08:16Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Demonstration to Support Black Lives Matter',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#dbdbdb',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103382484%2F306585256546%2F1%2Foriginal.20200612-045518?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C24%2C684%2C342&s=521392b5770145f65ac6d07e08fdc2e2',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103382484%2F306585256546%2F1%2Foriginal.20200612-045518?auto=format%2Ccompress&q=75&sharp=10&s=79f8be2ac447a3564c63fb58d46be6e0',
                        width: 685,
                        height: 391,
                    },
                    crop_mask: {
                        width: 684,
                        height: 342,
                        top_left: {
                            y: 24,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103382484',
                },
                timezone: 'America/New_York',
                id: '109042719710',
                tickets_url:
                    'https://www.eventbrite.com/e/demonstration-to-support-black-lives-matter-tickets-109042719710',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30476726104',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '18:00',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/12004',
                        display_name: 'Non-partisan',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/112',
                        display_name: 'Government & Politics',
                        localized: {
                            display_name: 'Government & Politics',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/100',
                        display_name: 'Other',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community',
                        display_name: 'Community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Human rights',
                        display_name: 'Human rights',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Rally',
                        display_name: 'Rally',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Demonstration',
                        display_name: 'Demonstration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Protest',
                        display_name: 'Protest',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/March',
                        display_name: 'March',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/George floyd',
                        display_name: 'George floyd',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: "OrganizerTag/I can't breathe",
                        display_name: "I can't breathe",
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Breonna taylor',
                        display_name: 'Breonna taylor',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109042719710',
                start_time: '17:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Mansfield',
                    venue_profile_id: null,
                    address: {
                        city: 'Mansfield',
                        country: 'US',
                        region: 'PA',
                        longitude: '-77.0773571',
                        localized_address_display:
                            '15 South main street , Mansfield, PA 16933',
                        postal_code: '16933',
                        address_1: '15 South main street ',
                        latitude: '41.8068861',
                        localized_multi_line_address_display: [
                            '15 South main street',
                            'Mansfield, PA 16933',
                        ],
                        localized_area_display: 'Mansfield, PA',
                    },
                    venue_profile_url: '',
                    id: '51174592',
                },
                series_id: null,
                image_id: '103382484',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51174592',
                checkout_flow: 'moflo',
                name: 'Demonstration to support Black Lives Matter',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/demonstration-to-support-black-lives-matter-tickets-109042719710',
                hide_start_date: false,
                summary:
                    'Show your support for the Black Lives Matter movement!',
                is_online_event: false,
                eid: 'ekmdgpb',
                published: '2020-06-10T20:28:45Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'JUNETEENTH at The Black Store: Beauty Supply Experience',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#523b29',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102805526%2F48057171770%2F1%2Foriginal.20200605-181139?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C16%2C1080%2C540&s=f6c7876a5c5320fa1a4d916a525f5896',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102805526%2F48057171770%2F1%2Foriginal.20200605-181139?auto=format%2Ccompress&q=75&sharp=10&s=884da7d91cd5a54cd909288633074229',
                        width: 1080,
                        height: 566,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 16,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102805526',
                },
                timezone: 'America/North_Dakota/Center',
                id: '106058519888',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-black-store-beauty-supply-experience-tickets-106058519888',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '29581586685',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13003',
                        display_name: 'City/Town',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/10',
                        display_name: 'Meeting or Networking Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Business',
                        display_name: 'Business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Networking',
                        display_name: 'Networking',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Food',
                        display_name: 'Food',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black',
                        display_name: 'Black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Fun',
                        display_name: 'Fun',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Food truck',
                        display_name: 'Food truck',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black culture',
                        display_name: 'Black culture',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black owned',
                        display_name: 'Black owned',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black event',
                        display_name: 'Black event',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteeth',
                        display_name: 'Juneteeth',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '106058519888',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'The Black Store: Beauty Supply Experience',
                    venue_profile_id: null,
                    address: {
                        city: 'Houston',
                        country: 'US',
                        region: 'TX',
                        longitude: '-95.35605229999999',
                        localized_address_display:
                            '8616 Cullen Boulevard, Houston, TX 77051',
                        postal_code: '77051',
                        address_1: '8616 Cullen Boulevard',
                        latitude: '29.6681776',
                        localized_multi_line_address_display: [
                            '8616 Cullen Boulevard',
                            'Houston, TX 77051',
                        ],
                        localized_area_display: 'Houston, TX',
                    },
                    venue_profile_url: '',
                    id: '50714226',
                },
                series_id: null,
                image_id: '102805526',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '50714226',
                checkout_flow: 'moflo',
                name: 'JUNETEENTH at The Black Store: Beauty Supply Experience',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-at-the-black-store-beauty-supply-experience-tickets-106058519888',
                hide_start_date: false,
                summary:
                    'THE BLACK STORE: Beauty Supply Experience is celebrating JUNETEENTH',
                is_online_event: false,
                eid: 'ekgfbfb',
                published: '2020-05-20T05:14:51Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Our Lives Matter Youth Rally',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#070806',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103232984%2F452164392708%2F1%2Foriginal.20200610-194055?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C315%2C2550%2C1275&s=dd59d6c37ca63142adcf06f2aaed3bfe',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103232984%2F452164392708%2F1%2Foriginal.20200610-194055?auto=format%2Ccompress&q=75&sharp=10&s=c4d807a4f000954f26757b235d5a4baf',
                        width: 2550,
                        height: 3300,
                    },
                    crop_mask: {
                        width: 2550,
                        height: 1275,
                        top_left: {
                            y: 315,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103232984',
                },
                timezone: 'America/New_York',
                id: '109039269390',
                tickets_url:
                    'https://www.eventbrite.com/e/our-lives-matter-youth-rally-tickets-109039269390',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30476536788',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13010',
                        display_name: 'Historic',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Teen',
                        display_name: 'Teen',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blacklivesmatter',
                        display_name: 'Blacklivesmatter',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109039269390',
                start_time: '14:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Antorcha de la Amistad',
                    venue_profile_id: null,
                    address: {
                        city: 'Miami',
                        country: 'US',
                        region: 'FL',
                        longitude: '-80.1876504',
                        localized_address_display:
                            '301 Biscayne Boulevard, Miami, FL 33132',
                        postal_code: '33132',
                        address_1: '301 Biscayne Boulevard',
                        latitude: '25.7776527',
                        localized_multi_line_address_display: [
                            '301 Biscayne Boulevard',
                            'Miami, FL 33132',
                        ],
                        localized_area_display: 'Miami, FL',
                    },
                    venue_profile_url: '',
                    id: '51174200',
                },
                series_id: null,
                image_id: '103232984',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51174200',
                checkout_flow: 'moflo',
                name: 'Our Lives Matter Youth Rally',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/our-lives-matter-youth-rally-tickets-109039269390',
                hide_start_date: false,
                summary: '***MASKS ARE MANDATORY!!!!!!!***',
                is_online_event: false,
                eid: 'ekmhmrb',
                published: '2020-06-10T19:57:18Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Community Panel and Annual Chili Tasting',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#917a4b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102843924%2F144995660222%2F1%2Foriginal.20200606-084117?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C14%2C718%2C359&s=5c141d69ab37f0e7f2667e10bf16379e',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102843924%2F144995660222%2F1%2Foriginal.20200606-084117?auto=format%2Ccompress&q=75&sharp=10&s=679b0d7d9636d37adcaa6271172fd702',
                        width: 719,
                        height: 387,
                    },
                    crop_mask: {
                        width: 718,
                        height: 359,
                        top_left: {
                            y: 14,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102843924',
                },
                timezone: 'America/Los_Angeles',
                id: '108527941996',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-community-panel-and-annual-chili-tasting-tickets-108527941996',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '8227708605',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '14:30',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/199',
                        display_name: 'Other',
                        localized: {
                            display_name: 'Other',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/2',
                        display_name: 'Seminar or Talk',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black lives matter',
                        display_name: 'Black lives matter',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108527941996',
                start_time: '11:30',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Human Rights Education Institute',
                    venue_profile_id: null,
                    address: {
                        city: "Coeur d'Alene",
                        country: 'US',
                        region: 'ID',
                        longitude: '-116.78860002',
                        localized_address_display:
                            "414 West Fort Grounds Drive, Coeur d'Alene, ID 83814",
                        postal_code: '83814',
                        address_1: '414 West Fort Grounds Drive',
                        latitude: '47.675622766882',
                        localized_multi_line_address_display: [
                            '414 West Fort Grounds Drive',
                            "Coeur d'Alene, ID 83814",
                        ],
                        localized_area_display: "Coeur d'Alene, ID",
                    },
                    venue_profile_url: '',
                    id: '51060686',
                },
                series_id: null,
                image_id: '102843924',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51060686',
                checkout_flow: 'moflo',
                name: 'JUNETEENTH COMMUNITY PANEL  AND ANNUAL CHILI TASTING',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-community-panel-and-annual-chili-tasting-tickets-108527941996',
                hide_start_date: false,
                summary: 'Community Panel discussion around Black Lives Matter',
                is_online_event: false,
                eid: 'ekkmchr',
                published: '2020-06-06T08:43:51Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Black Owned Business Town Hall',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102865922%2F285621354321%2F1%2Foriginal.20200606-180622?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2160%2C1080&s=7aff15d2719a9a00791fae5777983915',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102865922%2F285621354321%2F1%2Foriginal.20200606-180622?auto=format%2Ccompress&q=75&sharp=10&s=16a548d41836594dfb77d1fbd827f1d8',
                        width: 2160,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 2160,
                        height: 1080,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102865922',
                },
                timezone: 'America/New_York',
                id: '108565319794',
                tickets_url:
                    'https://www.eventbrite.com/e/black-owned-business-town-hall-atl-tickets-108565319794',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28943188965',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '22:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/1999',
                        display_name: 'Other',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/101',
                        display_name: 'Business & Professional',
                        localized: {
                            display_name: 'Business & Professional',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/2',
                        display_name: 'Seminar or Talk',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atlanta',
                        display_name: 'Atlanta',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Business',
                        display_name: 'Business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black',
                        display_name: 'Black',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atl',
                        display_name: 'Atl',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black business',
                        display_name: 'Black business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black owned',
                        display_name: 'Black owned',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black owned business',
                        display_name: 'Black owned business',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Town hall',
                        display_name: 'Town hall',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Atlanta town hall',
                        display_name: 'Atlanta town hall',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108565319794',
                start_time: '19:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '5495 Old National Hwy',
                    venue_profile_id: null,
                    address: {
                        city: 'College Park',
                        country: 'US',
                        region: 'GA',
                        longitude: '-84.472498',
                        localized_address_display:
                            '5495 Old National Highway Suite B18, College Park, GA 30349',
                        postal_code: '30349',
                        address_1: '5495 Old National Highway',
                        address_2: 'Suite B18',
                        latitude: '33.60530190000001',
                        localized_multi_line_address_display: [
                            '5495 Old National Highway',
                            'Suite B18',
                            'College Park, GA 30349',
                        ],
                        localized_area_display: 'College Park, GA',
                    },
                    venue_profile_url: '',
                    id: '51071438',
                },
                series_id: null,
                image_id: '102865922',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51071438',
                checkout_flow: 'moflo',
                name: 'Black Owned Business Town Hall ATL',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/black-owned-business-town-hall-atl-tickets-108565319794',
                hide_start_date: false,
                summary:
                    'Black Owned Business town hall networking event to help build stronger black owned businesses and communities.',
                is_online_event: false,
                eid: 'ekkmzbw',
                published: '2020-06-06T18:44:02Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Chalk The Street - In Support of BLM',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#585b5a',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103154486%2F108249248397%2F1%2Foriginal.20200610-031436?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C37%2C1242%2C621&s=8733a3ad0ee0e5cac4db9170f6f29239',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103154486%2F108249248397%2F1%2Foriginal.20200610-031436?auto=format%2Ccompress&q=75&sharp=10&s=ffb48ded4da9d7ae7bfabb6ca39e468d',
                        width: 1242,
                        height: 699,
                    },
                    crop_mask: {
                        width: 1242,
                        height: 621,
                        top_left: {
                            y: 37,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103154486',
                },
                timezone: 'America/New_York',
                id: '108945328410',
                tickets_url:
                    'https://www.eventbrite.com/e/chalk-the-street-in-support-of-blm-tickets-108945328410',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '26430935435',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [],
                eventbrite_event_id: '108945328410',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Downtown Bloomfield',
                    venue_profile_id: null,
                    address: {
                        city: 'Downtown Bloomfield',
                        country: 'US',
                        region: 'NJ',
                        longitude: '-74.197211',
                        localized_address_display: 'Downtown Bloomfield, NJ',
                        latitude: '40.793386',
                        localized_multi_line_address_display: [
                            'Downtown Bloomfield, NJ',
                        ],
                        localized_area_display: 'Downtown Bloomfield, NJ',
                    },
                    venue_profile_url: '',
                    id: '51154486',
                },
                series_id: null,
                image_id: '103154486',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51154486',
                checkout_flow: 'moflo',
                name: 'Chalk the Street - In Support of BLM',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/chalk-the-street-in-support-of-blm-tickets-108945328410',
                hide_start_date: false,
                summary:
                    'The Bloom will be hosting a Chalk The Street Event, with support from The Bloomfield Alliance, in coordination with @Lovlee Art Studio and Stephen Crooks. On Sunday 2p-5p.  Artist Stephen Crooks will be creating a "Black Lives Matter" text on Washington Street which locals are invited to come and fill in with patterns and creativity. A family friendly event to demonstrate unity in a pacified space. Masks and Social Distancing is required.   If you are unable to attend the event, you can still pa',
                is_online_event: false,
                eid: '108945328410',
                published: '2020-06-10T03:14:21Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '2nd Annual Juneteenth Family Festival',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#dadbdf',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F92459657%2F273511846004%2F1%2Foriginal.20200213-230027?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C2400%2C1200&s=06abe4dee53d285d7e43b1da4c5ec7e3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F92459657%2F273511846004%2F1%2Foriginal.20200213-230027?auto=format%2Ccompress&q=75&sharp=10&s=e293253f34c7001efa29ebcd2ce6fc05',
                        width: 2400,
                        height: 3600,
                    },
                    crop_mask: {
                        width: 2400,
                        height: 1200,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '92459657',
                },
                timezone: 'America/Chicago',
                id: '94728632891',
                tickets_url:
                    'https://www.eventbrite.com/e/2nd-annual-juneteenth-family-festival-tickets-94728632891',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17914489720',
                hide_end_date: false,
                start_date: '2020-06-20',
                end_time: '17:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/5',
                        display_name: 'Festival or Fair',
                    },
                ],
                eventbrite_event_id: '94728632891',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Dan Ryan Woods',
                    venue_profile_id: null,
                    address: {
                        city: 'Chicago',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.68483200000003',
                        localized_address_display:
                            '8700 S. Western Avenue (Grove #7 & #8), Chicago, IL 60620',
                        postal_code: '60620',
                        address_1: '8700 S. Western Avenue (Grove #7 & #8)',
                        latitude: '41.7309539',
                        localized_multi_line_address_display: [
                            '8700 S. Western Avenue (Grove #7 & #8)',
                            'Chicago, IL 60620',
                        ],
                        localized_area_display: 'Chicago, IL',
                    },
                    venue_profile_url: '',
                    id: '48097649',
                },
                series_id: null,
                image_id: '92459657',
                is_cancelled: null,
                primary_venue_id: '48097649',
                checkout_flow: 'moflo',
                name: '2nd Annual Juneteenth Family Festival',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/2nd-annual-juneteenth-family-festival-tickets-94728632891',
                hide_start_date: false,
                summary:
                    "Come out and enjoy a day full of family fun as we celebrate Juneteenth! There will be live performances, arts & crafts, artists, face painting, food vendors, dj, games and activities for the whole family! Admission is free for the event. However, food, kids' activities and merhandise will be for sale. Our 2nd Annual Juneteenth Family Festival is hosted by Burst Into Books, Moms of Beverly and Southwest Chicago Diversity Collaborative. If you like to be a sponsor, vendor or for more information c",
                is_online_event: false,
                eid: '94728632891',
                published: '2020-02-13T23:04:07Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#98f8ca',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103128728%2F244103203513%2F1%2Foriginal.20200609-210536?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C310%2C692%2C346&s=bd93666c4e6ad841e064644401f8b021',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103128728%2F244103203513%2F1%2Foriginal.20200609-210536?auto=format%2Ccompress&q=75&sharp=10&s=7235095a4de17d700bb715b23b942073',
                        width: 692,
                        height: 1171,
                    },
                    crop_mask: {
                        width: 692,
                        height: 346,
                        top_left: {
                            y: 310,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103128728',
                },
                timezone: 'America/Chicago',
                id: '108916760964',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-108916760964',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17878018194',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '20:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [],
                eventbrite_event_id: '108916760964',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '1500 Park Rd, Whiting, IN 46394-1756, United States',
                    venue_profile_id: null,
                    address: {
                        localized_multi_line_address_display: [],
                        country: 'US',
                        longitude: '-87.5123149',
                        latitude: '41.686123',
                    },
                    venue_profile_url: '',
                    id: '51149850',
                },
                series_id: null,
                image_id: '103128728',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51149850',
                checkout_flow: 'moflo',
                name: 'Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-celebration-tickets-108916760964',
                hide_start_date: false,
                summary:
                    'YOU ALL REQUESTED AND WE ARE DELIVERING!! HERE IT IS!!JUNE 19, 2020 FREE SPIRITZ IN CONNECTION WITH OTHER POWERFUL BLACK BUSINESS OWNERS ARE THROWING A CELEBRATION OF LIFE, OF FREEDOM, OF UNITY, FOR US BY US! MUSIC, GAMES, FREE FOOD, & LETS ENJOY JUST BEING US!! BRING A LAWN CHAIR OR BLANKET.PLAN TO BE IN ATTENDANCE. BRING THE KIDS OUT. YES, WE ARE STILL LOOKING FOR SPONSORS FOR KID FRIENDLY ACTIVITIES, INFLATABLES, A DJ, AND MORE. IF YOUR BUSINESS OR ANY INDIVIDUAL WISHES TO BECOME A SPONSOR PL',
                is_online_event: false,
                eid: '108916760964',
                published: '2020-06-09T21:05:24Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Roll N Peace 5 - A Juneteenth Celebration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#ffffff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103339948%2F272021637054%2F1%2Foriginal.20200611-183701?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C118%2C1080%2C540&s=6cbc643740bae4232ba0ef8ef9500d81',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103339948%2F272021637054%2F1%2Foriginal.20200611-183701?auto=format%2Ccompress&q=75&sharp=10&s=93859de718dd2a2eae26303b3158f6dc',
                        width: 1080,
                        height: 1350,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 118,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103339948',
                },
                timezone: 'America/Chicago',
                id: '109193424472',
                tickets_url:
                    'https://www.eventbrite.com/e/roll-n-peace-5-a-juneteenth-celebration-registration-109193424472',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17844845600',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '22:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/107',
                        display_name: 'Health & Wellness',
                        localized: {
                            display_name: 'Health & Wellness',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/16',
                        display_name: 'Tour',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Chicago',
                        display_name: 'Chicago',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Cycling',
                        display_name: 'Cycling',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Bike',
                        display_name: 'Bike',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Englewood',
                        display_name: 'Englewood',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Roll n peace',
                        display_name: 'Roll n peace',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Think outside da block',
                        display_name: 'Think outside da block',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '109193424472',
                start_time: '16:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Engine Company 84 - 63rd & Halsted',
                    venue_profile_id: null,
                    address: {
                        city: 'Chicago',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.64641499999999',
                        localized_address_display:
                            '6204 South Green Street, Chicago, IL 60621',
                        postal_code: '60621',
                        address_1: '6204 South Green Street',
                        latitude: '41.78117649999999',
                        localized_multi_line_address_display: [
                            '6204 South Green Street',
                            'Chicago, IL 60621',
                        ],
                        localized_area_display: 'Chicago, IL',
                    },
                    venue_profile_url: '',
                    id: '51202358',
                },
                series_id: null,
                image_id: '103339948',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51202358',
                checkout_flow: 'moflo',
                name: 'Roll N Peace 5 - A Juneteenth Celebration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/roll-n-peace-5-a-juneteenth-celebration-registration-109193424472',
                hide_start_date: false,
                summary:
                    'Using cycling to address health and wellness Think Outside Da Block presents Roll N Peace 5 - A Juneteenth Celebration!',
                is_online_event: false,
                eid: 'ekmhbyb',
                published: '2020-06-11T20:25:28Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'March For US 2020 - Million Man March, Chicago',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#fefefe',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102864180%2F451525209528%2F1%2Foriginal.20200606-172356?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C298%2C726%2C363&s=f7d8b05053034d80dae101904337b89d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102864180%2F451525209528%2F1%2Foriginal.20200606-172356?auto=format%2Ccompress&q=75&sharp=10&s=6cd05902c1a1eafc3d6446f9bf1bc99d',
                        width: 726,
                        height: 960,
                    },
                    crop_mask: {
                        width: 726,
                        height: 363,
                        top_left: {
                            y: 298,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102864180',
                },
                timezone: 'America/Chicago',
                id: '108558497388',
                tickets_url:
                    'https://www.eventbrite.com/e/march-for-us-2020-million-man-march-chicago-tickets-108558497388',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30446359012',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '14:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [],
                eventbrite_event_id: '108558497388',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Chicago, Illinois',
                    venue_profile_id: null,
                    address: {
                        city: 'Chicago',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.632496',
                        localized_address_display: 'Chicago, IL',
                        latitude: '41.883222',
                        localized_multi_line_address_display: ['Chicago, IL'],
                        localized_area_display: 'Chicago, IL',
                    },
                    venue_profile_url: '',
                    id: '51070840',
                },
                series_id: null,
                image_id: '102864180',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51070840',
                checkout_flow: 'moflo',
                name: 'March For US 2020 - Million Man March, Chicago',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/march-for-us-2020-million-man-march-chicago-tickets-108558497388',
                hide_start_date: false,
                summary:
                    "This 1-Million-Man-March in Chicago, IL.... is FOR US! Let's Rise Up Together & March on Juneteenth (June 19th), the oldest nationally celebrated commemoration of the ending of slavery in the United States. Let Them Hear Us, Let Them See Us! Injustice Anywhere Is Injustice Everywhere! Share This Page & This Cause!",
                is_online_event: false,
                eid: '108558497388',
                published: '2020-06-06T17:23:51Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: "Bar University TV's 1st Annual Juneteenth BBQ",
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#515a23',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102930470%2F405823015007%2F1%2Foriginal.20200608-031100?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C38%2C1080%2C540&s=94e327660d569e1ffd291f599f7879f3',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102930470%2F405823015007%2F1%2Foriginal.20200608-031100?auto=format%2Ccompress&q=75&sharp=10&s=56c8296a8da2adf2e2a64af1d1ab1f3c',
                        width: 1080,
                        height: 1080,
                    },
                    crop_mask: {
                        width: 1080,
                        height: 540,
                        top_left: {
                            y: 38,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102930470',
                },
                timezone: 'America/Chicago',
                id: '108648781430',
                tickets_url:
                    'https://www.eventbrite.com/e/bar-university-tvs-1st-annual-juneteenth-bbq-tickets-108648781430',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30452552062',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '22:30',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/16999',
                        display_name: 'Other',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/116',
                        display_name: 'Seasonal & Holiday',
                        localized: {
                            display_name: 'Seasonal & Holiday',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Free',
                        display_name: 'Free',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Parties',
                        display_name: 'Parties',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Bbq',
                        display_name: 'Bbq',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/June events',
                        display_name: 'June events',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Adult event',
                        display_name: 'Adult event',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Bar university tv',
                        display_name: 'Bar university tv',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108648781430',
                start_time: '16:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '9628 S Harvard Ave',
                    venue_profile_id: null,
                    address: {
                        city: 'Chicago',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.63257759999999',
                        localized_address_display:
                            '9628 South Harvard Avenue, Chicago, IL 60628',
                        postal_code: '60628',
                        address_1: '9628 South Harvard Avenue',
                        latitude: '41.7188281',
                        localized_multi_line_address_display: [
                            '9628 South Harvard Avenue',
                            'Chicago, IL 60628',
                        ],
                        localized_area_display: 'Chicago, IL',
                    },
                    venue_profile_url: '',
                    id: '51096032',
                },
                series_id: null,
                image_id: '102930470',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51096032',
                checkout_flow: 'moflo',
                name: "Bar University TV's 1st Annual Juneteenth BBQ",
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/bar-university-tvs-1st-annual-juneteenth-bbq-tickets-108648781430',
                hide_start_date: false,
                summary:
                    "Forget The 4th It's Time to Celebrate OUR Accomplishments!",
                is_online_event: false,
                eid: 'ekkqtyp',
                published: '2020-06-08T03:35:57Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'WE WILL Support & Social Event- Evanston Juneteenth Parade',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#fcfcff',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F96508794%2F239486604964%2F1%2Foriginal.20200312-143650?w=370&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C49%2C370%2C185&s=d8424a93851dc8a04b1d9e03f961f648',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F96508794%2F239486604964%2F1%2Foriginal.20200312-143650?auto=format%2Ccompress&q=75&sharp=10&s=e225ec97aaf447e5f9439783e6555550',
                        width: 373,
                        height: 252,
                    },
                    crop_mask: {
                        width: 370,
                        height: 185,
                        top_left: {
                            y: 49,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '96508794',
                },
                timezone: 'America/Chicago',
                id: '99536548496',
                tickets_url:
                    'https://www.eventbrite.com/e/we-will-support-social-event-evanston-juneteenth-parade-tickets-99536548496',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '16206755679',
                hide_end_date: false,
                start_date: '2020-06-14',
                end_time: '14:00',
                _type: 'destination_event',
                end_date: '2020-06-14',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13010',
                        display_name: 'Historic',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/12',
                        display_name: 'Rally',
                    },
                ],
                eventbrite_event_id: '99536548496',
                start_time: '12:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '',
                    venue_profile_id: null,
                    address: {
                        city: 'Evanston',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.7607969',
                        localized_address_display:
                            'Dodge Avenue, Evanston, IL 60201',
                        postal_code: '60201',
                        address_1: 'Dodge Avenue',
                        latitude: '42.0639848',
                        localized_multi_line_address_display: [
                            'Dodge Avenue',
                            'Evanston, IL 60201',
                        ],
                        localized_area_display: 'Evanston, IL',
                    },
                    venue_profile_url: '',
                    id: '49617368',
                },
                series_id: null,
                image_id: '96508794',
                is_cancelled: null,
                primary_venue_id: '49617368',
                checkout_flow: 'moflo',
                name:
                    'WE WILL Support & Social Event- Evanston Juneteenth Parade',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/we-will-support-social-event-evanston-juneteenth-parade-tickets-99536548496',
                hide_start_date: false,
                summary:
                    'Learn More about We WIll.\nJoin the We Will chat on Facebook.',
                is_online_event: false,
                eid: '99536548496',
                published: '2020-03-12T14:40:14Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Festival',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#423a28',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102727944%2F451144348030%2F1%2Foriginal.20200604-214537?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C112%2C694%2C347&s=38e460d4e5013c4a035acec80a12c738',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102727944%2F451144348030%2F1%2Foriginal.20200604-214537?auto=format%2Ccompress&q=75&sharp=10&s=07a88bf0d5e51d54f1b1e69f69dd45d7',
                        width: 695,
                        height: 899,
                    },
                    crop_mask: {
                        width: 694,
                        height: 347,
                        top_left: {
                            y: 112,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102727944',
                },
                timezone: 'America/Chicago',
                id: '108258883234',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-festival-tickets-108258883234',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '30435479384',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '00:00',
                _type: 'destination_event',
                end_date: '2020-06-20',
                tags: [
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/11',
                        display_name: 'Party or Social Gathering',
                    },
                ],
                eventbrite_event_id: '108258883234',
                start_time: '15:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '3256 Ohio Ave',
                    venue_profile_id: null,
                    address: {
                        city: 'St. Louis',
                        country: 'US',
                        region: 'MO',
                        longitude: '-90.227131',
                        localized_address_display:
                            '3256 Ohio Avenue, St. Louis, MO 63118',
                        postal_code: '63118',
                        address_1: '3256 Ohio Avenue',
                        latitude: '38.59547329999999',
                        localized_multi_line_address_display: [
                            '3256 Ohio Avenue',
                            'St. Louis, MO 63118',
                        ],
                        localized_area_display: 'St. Louis, MO',
                    },
                    venue_profile_url: '',
                    id: '51028210',
                },
                series_id: null,
                image_id: '102727944',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51028210',
                checkout_flow: 'moflo',
                name: 'Juneteenth Festival',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-festival-tickets-108258883234',
                hide_start_date: false,
                summary: 'Celebrating Black Freedom',
                is_online_event: false,
                eid: '108258883234',
                published: '2020-06-04T21:51:46Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: '"On Their Shoulder" Juneteenth Commemoration',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#898983',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95075023%2F163263326996%2F1%2Foriginal.20200303-051725?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C957%2C1414%2C707&s=8cb86fcf916e51931e2830766b5db47d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F95075023%2F163263326996%2F1%2Foriginal.20200303-051725?auto=format%2Ccompress&q=75&sharp=10&s=3d03c02df0e5ffc1ec7c601d2065fee7',
                        width: 1414,
                        height: 2000,
                    },
                    crop_mask: {
                        width: 1414,
                        height: 707,
                        top_left: {
                            y: 957,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '95075023',
                },
                timezone: 'America/Chicago',
                id: '97908217113',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-commemoration-tickets-97908217113',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '28910699117',
                hide_end_date: false,
                start_date: '2020-06-21',
                end_time: '15:30',
                _type: 'destination_event',
                end_date: '2020-06-21',
                tags: [],
                eventbrite_event_id: '97908217113',
                start_time: '14:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Gateway Arch',
                    venue_profile_id: null,
                    address: {
                        localized_multi_line_address_display: [],
                        country: 'US',
                        longitude: '-90.185866355896',
                        latitude: '38.625554553987',
                    },
                    venue_profile_url: '',
                    id: '50956348',
                },
                series_id: null,
                image_id: '95075023',
                is_cancelled: null,
                primary_venue_id: '50956348',
                checkout_flow: 'moflo',
                name: 'Juneteenth Commemoration',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-commemoration-tickets-97908217113',
                hide_start_date: false,
                summary:
                    'On Sunday, June 21, 2020, at 2PM we will commemorate our ancestors Celebrating Juneteenth by giving them a proper burial for the 500+ Slave that was sold on the Arch grounds during the 1700s along with the lives of those recently murdered by police brutality." If we stand tall, it\'s because we stand on the shoulders of our ancestors"-African ProverbWe have decided that the time has come to strive for healing. for our ancestors that were sold to bondage enduring dehumanizing hate crimes for skin',
                is_online_event: false,
                eid: '97908217113',
                published: '2020-03-03T05:17:32Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title:
                'Virtual Juneteenth Journey Through African American History & Forum',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#000000',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102837864%2F56288904347%2F1%2Foriginal.20200606-040105?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C288%2C2304%2C1152&s=7c6f4dc73b0620c3be7a706d8d41e51d',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F102837864%2F56288904347%2F1%2Foriginal.20200606-040105?auto=format%2Ccompress&q=75&sharp=10&s=88696cd8ebc8097bbbd044916fe4fcae',
                        width: 2304,
                        height: 1728,
                    },
                    crop_mask: {
                        width: 2304,
                        height: 1152,
                        top_left: {
                            y: 288,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '102837864',
                },
                timezone: 'America/Chicago',
                id: '102410394246',
                tickets_url:
                    'https://www.eventbrite.com/e/virtual-juneteenth-journey-through-african-american-history-forum-tickets-102410394246',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '6141130087',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '21:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/6',
                        display_name: 'Concert or Performance',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Theater',
                        display_name: 'Theater',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Family',
                        display_name: 'Family',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Date night',
                        display_name: 'Date night',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Black culture',
                        display_name: 'Black culture',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '102410394246',
                start_time: '18:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: '17601 Wentworth Ave',
                    venue_profile_id: null,
                    address: {
                        city: 'Lansing',
                        country: 'US',
                        region: 'IL',
                        longitude: '-87.5290835',
                        localized_address_display:
                            '17601 Wentworth Avenue, Lansing, IL 60438',
                        postal_code: '60438',
                        address_1: '17601 Wentworth Avenue',
                        latitude: '41.57549009999999',
                        localized_multi_line_address_display: [
                            '17601 Wentworth Avenue',
                            'Lansing, IL 60438',
                        ],
                        localized_area_display: 'Lansing, IL',
                    },
                    venue_profile_url: '',
                    id: '50211232',
                },
                series_id: null,
                image_id: '102837864',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '50211232',
                checkout_flow: 'moflo',
                name:
                    'VIRTUAL JUNETEENTH JOURNEY THROUGH AFRICAN AMERICAN HISTORY & FORUM',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/virtual-juneteenth-journey-through-african-american-history-forum-tickets-102410394246',
                hide_start_date: false,
                summary:
                    'For Your Joy MMP (Multimedia Productions) takes a journey through African American History in this Juneteenth performance forum event.',
                is_online_event: false,
                eid: 'ehzyxzw',
                published: '2020-04-10T19:59:17Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Juneteenth Community Bike',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#716e5b',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103308828%2F172890659866%2F1%2Foriginal.20200611-141059?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C960%2C480&s=1ca0d77174d50305dbb1e068f130a478',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F103308828%2F172890659866%2F1%2Foriginal.20200611-141059?auto=format%2Ccompress&q=75&sharp=10&s=000689608fdab0d4d24f74adda0054f9',
                        width: 960,
                        height: 695,
                    },
                    crop_mask: {
                        width: 960,
                        height: 480,
                        top_left: {
                            y: 0,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '103308828',
                },
                timezone: 'America/New_York',
                id: '108255095906',
                tickets_url:
                    'https://www.eventbrite.com/e/juneteenth-community-bike-tickets-108255095906',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '17310189020',
                hide_end_date: false,
                start_date: '2020-06-19',
                end_time: '15:00',
                _type: 'destination_event',
                end_date: '2020-06-19',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13007',
                        display_name: 'Heritage',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/15',
                        display_name: 'Race or Endurance Event',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Community',
                        display_name: 'Community',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Bike ride',
                        display_name: 'Bike ride',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Celebration',
                        display_name: 'Celebration',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Louisville',
                        display_name: 'Louisville',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Juneteenth',
                        display_name: 'Juneteenth',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/502',
                        display_name: '502',
                        prefix: 'OrganizerTag',
                    },
                    {
                        _type: 'tag',
                        tag: 'OrganizerTag/Blm',
                        display_name: 'Blm',
                        prefix: 'OrganizerTag',
                    },
                ],
                eventbrite_event_id: '108255095906',
                start_time: '11:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Wyandotte Park',
                    venue_profile_id: null,
                    address: {
                        city: 'Louisville',
                        country: 'US',
                        region: 'KY',
                        longitude: '-85.7806545',
                        localized_address_display:
                            '1104 Beecher Street, Louisville, KY 40215',
                        postal_code: '40215',
                        address_1: '1104 Beecher Street',
                        latitude: '38.1908566',
                        localized_multi_line_address_display: [
                            '1104 Beecher Street',
                            'Louisville, KY 40215',
                        ],
                        localized_area_display: 'Louisville, KY',
                    },
                    venue_profile_url: '',
                    id: '51027530',
                },
                series_id: null,
                image_id: '103308828',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '51027530',
                checkout_flow: 'moflo',
                name: 'Juneteenth Community Bike',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/juneteenth-community-bike-tickets-108255095906',
                hide_start_date: false,
                summary:
                    'Community Bike Ride Event\n-Celebrating Juneteeth\n-Promoting positivity in our community\n-Promoting healthy recreation',
                is_online_event: false,
                eid: 'ekkfyxy',
                published: '2020-06-11T14:31:25Z',
            },
        },
        {
            custom_description: null,
            custom_image_id: null,
            custom_title: 'Nashville Black History Walking Tour',
            event: {
                image: {
                    edge_color_set: true,
                    edge_color: '#6b82a2',
                    url:
                        'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F79248151%2F283658637810%2F1%2Foriginal.20191104-031231?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C455%2C3644%2C1822&s=8852583180cf4d98ff6fcf81538197de',
                    original: {
                        url:
                            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F79248151%2F283658637810%2F1%2Foriginal.20191104-031231?auto=format%2Ccompress&q=75&sharp=10&s=31435e37f7a40db179ad1ca214304928',
                        width: 3644,
                        height: 2732,
                    },
                    crop_mask: {
                        width: 3644,
                        height: 1822,
                        top_left: {
                            y: 455,
                            x: 0,
                        },
                    },
                    aspect_ratio: '2',
                    id: '79248151',
                },
                timezone: 'America/Chicago',
                id: '79992599017',
                tickets_url:
                    'https://www.eventbrite.com/e/nashville-black-history-walking-tour-tickets-79992599017',
                tickets_by: 'Eventbrite',
                primary_organizer_id: '18243016421',
                hide_end_date: false,
                start_date: '2020-06-12',
                end_time: '11:00',
                _type: 'destination_event',
                end_date: '2020-06-12',
                tags: [
                    {
                        prefix: 'EventbriteSubCategory',
                        tag: 'EventbriteSubCategory/13010',
                        display_name: 'Historic',
                    },
                    {
                        prefix: 'EventbriteCategory',
                        tag: 'EventbriteCategory/113',
                        display_name: 'Community & Culture',
                        localized: {
                            display_name: 'Community & Culture',
                        },
                    },
                    {
                        prefix: 'EventbriteFormat',
                        tag: 'EventbriteFormat/16',
                        display_name: 'Tour',
                    },
                ],
                eventbrite_event_id: '79992599017',
                start_time: '09:00',
                primary_venue: {
                    _type: 'destination_venue',
                    name: 'Nashville Visitor Center',
                    venue_profile_id: null,
                    address: {
                        city: 'Nashville',
                        country: 'US',
                        region: 'TN',
                        longitude: '-86.7784959',
                        localized_address_display:
                            '501 Broadway We will meet outside by the front door of the Nashville Visitor Center. You may park in any public lots or garages nearby. , Nashville, TN 37203',
                        postal_code: '37203',
                        address_1: '501 Broadway',
                        address_2:
                            'We will meet outside by the front door of the Nashville Visitor Center. You may park in any public lots or garages nearby. ',
                        latitude: '36.1591736',
                        localized_multi_line_address_display: [
                            '501 Broadway',
                            'We will meet outside by the front door of the Nashville Visitor Center. You may park in any public lots or garages nearby.',
                            'Nashville, TN 37203',
                        ],
                        localized_area_display: 'Nashville, TN',
                    },
                    venue_profile_url: '',
                    id: '41819663',
                },
                series_id: '79992532819',
                image_id: '79248151',
                is_protected_event: false,
                is_cancelled: null,
                primary_venue_id: '41819663',
                checkout_flow: 'moflo',
                name: 'Nashville Black History Walking Tour',
                language: 'en-us',
                url:
                    'https://www.eventbrite.com/e/nashville-black-history-walking-tour-tickets-79992599017',
                hide_start_date: false,
                summary:
                    'Come join us on a unique downtown Nashville walking tour! Imagine being able to look beyond the single-story narrative and get up close and personal with the soul of the Music City. \nTogether we’ll trace the footsteps of legendary musicians such as country music star Charley Pride, and the iconic Fisk Jubilee Singers. Combine that with a splash of storytelling about early black life in Nashville with United Street Tours. Enjoy strolling from Lower Broadway, the most visited street in Nashville; ',
                is_online_event: false,
                eid: '79992599017',
                published: '2019-11-04T03:33:46Z',
            },
        },
    ],
};

export const mapOptions = {
    panControl: false,
    mapTypeControl: false,
    scrollwheel: false,
    fullscreenControl: false,
    // zoom controls, leave in case
    // disableDefaultUI: true,

    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#1c1c1e',
                },
            ],
        },
        {
            featureType: 'administrative.country',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.icon',
            stylers: [
                {
                    color: '#1e1e20',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#3a3a40',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#1c1c1e',
                },
            ],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi.place_of_worship',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#242426',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#1b1b1d',
                },
                {
                    visibility: 'off',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.local',
            stylers: [
                {
                    color: '#242426',
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#2d2d30',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
        {
            featureType: 'transit.station',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit.station.airport',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#18181a',
                },
            ],
        },
        {
            featureType: 'transit.station.airport',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#64646b',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#020203',
                },
            ],
        },
    ],
};
